<template>
	<div class="infor fl">
		<AllHeader :label="lable" :ischage="ischage" :sublabel="sublabel" :subtitle="subtitle" :year="year"
			@getvalue="getvalue" v-if="step > 0" />
		<div v-if="step == 0">
		        <div style="position:relative; " class="topnavs">
		             <el-radio-group v-model="activestatus" @input="handlecstatus" >
                        <el-radio-button label="2">待审核</el-radio-button>
                        <el-radio-button label="3">已审核</el-radio-button>
                      </el-radio-group>
	                     <div style="display:flex;justify-content:center;align-items:center">
                            <span>{{bname}}</span>
                            <div class="infor-t-r" @click="toBatch" style="margin-left:20px; cursor: pointer;">
                    			<span>返回批次</span>
                    		</div>
                        </div>
		        </div>
                    <div class="wtype-tabs">
                        <span :class="['wtype-tab-item', activewtype === '房屋建筑工程' ? 'active' : '']" @click="activewtype = '房屋建筑工程'; handlewtype()">房屋建筑工程</span>
                        <span :class="['wtype-tab-item', activewtype === '土木工程' ? 'active' : '']" @click="activewtype = '土木工程'; handlewtype()">土木工程</span>
                        <span :class="['wtype-tab-item', activewtype === '工业安装工程' ? 'active' : '']" @click="activewtype = '工业安装工程'; handlewtype()">工业安装工程</span>
                    </div>
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-top:20px;">
                        <el-form ref="queryForm" size="small" :inline="true" label-width="68px" style="text-align:left;margin-bottom:0;">
                            <el-form-item prop="reviewStatus" style="margin-bottom:0;">
                                <el-select style="width: 150px" v-model="reviewStatus" placeholder="评审情况" clearable>
                                    <el-option label="待分配" value="待分配" />
                                    <el-option label="初审中" value="待初审" />
                                    <el-option label="待中审" value="待中审" />
                                    <el-option label="待终审" value="待终审" />
                                    <el-option label="专家退回" value="已退回" />
                                    <el-option label="逾期终止" value="超时终止" />
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="searchField" style="margin-bottom:0;">
                                <el-select style="width: 150px" v-model="searchField" placeholder="搜索项" clearable>
                                    <el-option label="单位" value="unit" />
                                    <el-option label="工法名称" value="name" />
                                    <el-option label="工法完成人" value="author" />
                                    <el-option label="序号" value="no" />
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="keyword" style="margin-bottom:0;">
                                <el-input style="width: 200px"
                                          v-model="keyword"
                                    :placeholder="searchPlaceholder"
                                    clearable/>
                            </el-form-item>
                            <el-form-item style="margin-bottom:0;">
                                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                            </el-form-item>
                        </el-form>
                        <div style="display:flex;align-items:center;gap:8px;">
                            <el-button type="primary" size="mini" @click="downloadSummaryTable">汇总表下载</el-button>
                            <el-button type="primary" size="mini" :disabled="selected_log_ids.length === 0" @click="downloadReviewTable">评审表下载</el-button>
                            <el-button type="danger" size="mini" :disabled="selected_log_ids.length === 0" @click="handleBatchChecked('reject')">批量不通过</el-button>
                            <el-button type="success" size="mini" :disabled="selected_log_ids.length === 0" @click="handleBatchChecked('approve')">批量通过</el-button>
                        </div>
                    </div>
                    <div style="width:100%;text-align:right;font-size:13px;color:#606266;margin-top:10px;" v-if="total">总共 {{total}} 条记录</div>

			<el-table ref="awardTable" :data="formlist"
                      v-loading="loading"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%; margin-top: 10px" :cell-style="{'text-align':'center'}" @selection-change="handleSelectionChange" @sort-change="handleSortChange" @filter-change="handleTableFilterChange">
			     <el-table-column type="selection" width="55" :selectable="canSelectForLeaderBatch">  </el-table-column>
				<el-table-column label="序号" min-width="80">
				    <template slot-scope="scope">
				        <div v-if="scope.row.sms_fail_info"
				             style="background:#FF3041;padding:4px 8px;font-weight:400;font-size:10px;color:#FFFFFF;line-height:24px;cursor:pointer;margin-bottom:4px;display:inline-block;"
				             @click="openSmsFailDialog(scope.row.sms_fail_info)">通知失败</div>
				        <div>{{ scope.row.no }}</div>
				    </template>
				</el-table-column>
				<el-table-column label="状态" min-width="80" column-key="table_status" :filters="getStatusFilterOptions()" :filter-multiple="false">
				    <template slot-scope="scope">
                          <span :style="{color: getStatusColor(scope.row.status)}">{{ getStatusText(scope.row.status) }}</span>
                    </template>
				</el-table-column>
				<el-table-column label="单位" min-width="100">
				    <template slot-scope="scope">
                          {{ getRowInfo(scope.row).unit || '-' }}
                    </template>
				</el-table-column>
				<el-table-column label="企业注册地" min-width="100">
				    <template slot-scope="scope">
                          {{ getRegisterProvince(scope.row) }}
                    </template>
				</el-table-column>
				<el-table-column label="工法名称" min-width="80">
				    <template slot-scope="scope">
                          {{ getRowInfo(scope.row).name || '-' }}
                    </template>
				</el-table-column>
				<el-table-column label="工法完成人" min-width="160">
				    <template slot-scope="scope">
				          <span>{{ scope.row.author_names_text || formatAuthorNames(scope.row) }}</span>
                    </template>
				</el-table-column>
				<el-table-column
                    label="主审"
                    min-width="60"
                    column-key="mainexpert"
                    :filters="mainExpertFilterOptions"
                    :filter-multiple="false">
				    <template slot-scope="scope">
                          <span v-if="scope.row.mainexpert">{{ scope.row.mainexpert.expert.name }}</span>
                          <span v-else>专家1</span>
                    </template>
				</el-table-column>
				<el-table-column label="结果" min-width="60" column-key="primary_result" :filters="getExpertResultFilterOptions()" :filter-multiple="false">
				    <template slot-scope="scope">
                          <span v-if="scope.row.mainexpert && scope.row.primary_checked_status > 0"
                                :style="{color: getReviewResultColor(scope.row.primary_checked_status), cursor:'pointer'}"
                                @click="openExpertDetail(scope.row, 'main')">
                              {{ getReviewResultText(scope.row.primary_checked_status) }}
                          </span>
                          <span v-else :style="{color: getReviewResultColor(scope.row.primary_checked_status)}">
                              {{ scope.row.mainexpert ? getReviewResultText(scope.row.primary_checked_status) : '-' }}
                          </span>
                    </template>
				</el-table-column>
				<el-table-column
                    label="副审"
                    min-width="60"
                    column-key="reexpert"
                    :filters="reExpertFilterOptions"
                    :filter-multiple="false">
				    <template slot-scope="scope">
                          <span v-if="scope.row.reexpert">{{ scope.row.reexpert.expert.name }}</span>
                          <span v-else>-</span>
                    </template>
				</el-table-column>
				<el-table-column label="结果" min-width="60" column-key="secondary_result" :filters="getExpertResultFilterOptions()" :filter-multiple="false">
				    <template slot-scope="scope">
                          <span v-if="scope.row.reexpert && scope.row.secondary_checked_status > 0"
                                :style="{color: getReviewResultColor(scope.row.secondary_checked_status), cursor:'pointer'}"
                                @click="openExpertDetail(scope.row, 'second')">
                              {{ getReviewResultText(scope.row.secondary_checked_status) }}
                          </span>
                          <span v-else :style="{color: getReviewResultColor(scope.row.secondary_checked_status)}">
                              {{ scope.row.reexpert ? getReviewResultText(scope.row.secondary_checked_status) : '-' }}
                          </span>
                    </template>
				</el-table-column>
				<el-table-column label="组长" min-width="60">
				    <template slot-scope="scope">
                          <span v-if="scope.row.leader">{{ scope.row.leader.expert.name }}</span>
                          <span v-else>-</span>
                    </template>
				</el-table-column>
				<el-table-column label="结果" min-width="60" column-key="leader_result" :filters="getExpertResultFilterOptions()" :filter-multiple="false">
				    <template slot-scope="scope">
                          <span v-if="scope.row.leader"
                                :style="{color: getReviewResultColor(scope.row.leader_checked_status), cursor:'pointer'}"
                                @click="openLeaderResultDialog(scope.row)">
                              {{ getReviewResultText(scope.row.leader_checked_status) }}
                          </span>
                          <span v-else>-</span>
                    </template>
				</el-table-column>
				<el-table-column prop="created_at" label="提交时间" min-width="130" sortable></el-table-column>
				<el-table-column label="终审" min-width="60" column-key="final_result" :filters="getFinalResultFilterOptions()" :filter-multiple="false">
				    <template slot-scope="scope">
                          <span v-if="scope.row.status == 5"
                                style="color:#67C23A;cursor:pointer;"
                                @click="openFinalResultDialog(scope.row)">通过</span>
                          <span v-else-if="scope.row.status == 6"
                                style="color:#F56C6C;cursor:pointer;"
                                @click="openFinalResultDialog(scope.row)">不通过</span>
                          <span v-else>-</span>
                    </template>
				</el-table-column>

				<el-table-column min-width="120" label="操作" fixed="right">
					<template slot-scope="scope">
                            <span v-if="getOperationText(scope.row) === '数据审核中'" style="color:#595959;">数据审核中</span>
                            <span v-else-if="getOperationText(scope.row) === '等待企业修改'" style="color:#595959;">等待企业修改</span>
                            <el-button v-else-if="getOperationText(scope.row) === '审核'" @click="toDetail(scope.row)" size="mini" type="primary">审核</el-button>
                            <el-button v-else-if="getOperationText(scope.row) === '查阅'" @click="toDetail(scope.row)" size="mini">查阅</el-button>
                            <template v-else>
                                <el-button @click="toDetail(scope.row)" size="mini" style="margin-bottom:4px;">查阅</el-button>
                                <el-button v-if="scope.row.can_admin_reject" size="mini" type="warning" @click="openAdminRejectDialog(scope.row)" style="margin-bottom:4px;">预审退回</el-button>
                            </template>
					</template>
				</el-table-column>
			</el-table>
			<Pagetion :total="total" @getpageValue="getpageValue" class="pos-page" />
            <el-dialog title="导出" :visible.sync="download" width="500px">
                <div class="form_right" style="width:400px">
                    <div class="form_1">
                        <div class="form_box_content">
                            <div class="flex">
                                <div class="my_form2">
                                    <div class="form_title" style="">日期</div>
                                    <div class="form_content">
                                        <el-date-picker
                                            v-model="timeRange"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                        </el-date-picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="exportInfo">导 出</el-button>
                  </span>
            </el-dialog>
		</div>
		<div v-if="step==1">
			<el-table :data="detailSummary ? [detailSummary] : []"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%;" :cell-style="{'text-align':'center'}">
				<el-table-column label="序号" min-width="70">
				    <template>
				        {{ detailSummary ? detailSummary.no : '-' }}
				    </template>
				</el-table-column>
				<el-table-column label="申请单位" min-width="120">
				    <template>
				        {{ detailSummary ? detailSummary.unit : '-' }}
				    </template>
				</el-table-column>
				<el-table-column label="企业注册地" min-width="100">
				    <template>
				        {{ detailSummary ? detailSummary.register_province : '-' }}
				    </template>
				</el-table-column>
				<el-table-column label="工法类型" min-width="100">
				    <template>
				        {{ detailSummary ? detailSummary.type_of_work : '-' }}
				    </template>
				</el-table-column>
				<el-table-column label="工法名称" min-width="120">
				    <template>
				        {{ detailSummary ? detailSummary.name : '-' }}
				    </template>
				</el-table-column>
				<el-table-column label="工法完成人" min-width="120">
				    <template>
				        <span>{{ detailSummary ? detailSummary.author_names : '-' }}</span>
				    </template>
				</el-table-column>
				<el-table-column label="提交时间" min-width="130">
				    <template>
				        {{ detailSummary ? detailSummary.created_at : '-' }}
				    </template>
				</el-table-column>
				<el-table-column v-if="curObj && ![5,6].includes(Number(curObj.status))" label="操作" min-width="90">
				    <template>
				        <el-button size="mini" type="primary" @click="openFinalReviewDialog(detailSummary)">审核</el-button>
				    </template>
				</el-table-column>
			</el-table>
			
			
			
			<el-tabs style="" v-model="activeName" tab-position="top">
				<el-tab-pane label="材料审核" name="first">
					<!-- 工法基本信息 -->
					<div class="form_right" style="border:1px solid #DDD;width:auto;margin-bottom:16px;margin-top:10px;">
						<div class="form_1" style="padding:0;margin:0;">
							<div class="form_box_content binfobase">
								<div class="flex"><div class="my_form2"><div class="form_title">工程类别</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_work}}</div></div></div>
								<div class="flex"><div class="my_form2"><div class="form_title">专业分类</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.type_of_major}}</div></div></div>
								<div class="flex"><div class="my_form2"><div class="form_title">工法名称</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.name}}</div></div></div>
								<div class="flex"><div class="my_form2"><div class="form_title">编写单位</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.unit}}</div></div></div>
								<div class="flex"><div class="my_form2"><div class="form_title">工法完成人</div><div class="form_content"><span v-if="parameters.info && parameters.info.author_names"><block v-for="(author,index) in parameters.info.author_names" :key="index">{{ author.name }}<block v-if="index + 1 < parameters.info.author_names.length">、</block></block></span><span v-else>-</span></div></div></div>
								<div class="flex"><div class="my_form2"><div class="form_title">申报联系人/联系电话</div><div class="form_content">{{parameters.info == undefined ? '' : parameters.info.username+'/'+parameters.info.phone}}</div></div></div>
							</div>
						</div>
					</div>
					<!-- 文件列表 -->
					<div style="display:flex;align-items:center;background:#F5F6F7;padding:8px 12px;font-size:13px;color:#808895;border-bottom:1px solid #EBEEF5;">
						<span style="width:50px;flex-shrink:0;text-align:center;">序号</span>
						<span style="flex:1;text-align:left;">文件</span>
						<span style="width:90px;text-align:center;">操作</span>
					</div>
					<div v-for="(row, idx) in temUnitlist" :key="idx"
						style="display:flex;align-items:center;padding:8px 12px;border-bottom:1px solid #EBEEF5;">
						<span style="width:50px;flex-shrink:0;text-align:center;">{{ idx + 1 }}</span>
						<span style="flex:1;color:#262626;text-align:left;">{{ row.name }}</span>
						<span style="width:90px;text-align:center;">
							<template v-if="getFileUrls(row).length">
								<a v-for="(file, fileIndex) in getFileUrls(row)" :key="file.url" class="a01" :href="file.url" target="_blank" style="display:block;">{{ formatFileLinkLabel(file, fileIndex) }}</a>
							</template>
							<span v-else style="color:#C0C4CC;">未上传</span>
						</span>
					</div>
				</el-tab-pane>
				<el-tab-pane label="审核意见" name="three">
				        <el-tabs tab-position="top" v-model="activeopinion" style="margin-top:10px;">
        				    <el-tab-pane label="组长" name="leader">
    				        <div v-if="curObj && curObj.leader" style="padding:12px 0;">
    				            <table style="width:100%;border-collapse:collapse;font-size:14px;text-align:left;">
    				                <tr>
    				                    <td style="width:140px;padding:10px 14px;border:1px solid #E4E7ED;color:#7C828A;white-space:nowrap;">组长审核结果：</td>
    				                    <td style="padding:10px 14px;border:1px solid #E4E7ED;"
    				                        :style="{color: getReviewResultColor(curObj.leader_checked_status), fontWeight:'600'}">
    				                        {{ getReviewResultText(curObj.leader_checked_status) }}
    				                    </td>
    				                </tr>
    				                <tr>
    				                    <td colspan="2" style="padding:10px 14px;border:1px solid #E4E7ED;line-height:1.8;">
    				                        <div style="color:#7C828A;margin-bottom:6px;">组长审核意见：</div>
    				                        <div style="color:#303133;white-space:pre-wrap;">{{ curObj.leader.content || '暂无意见' }}</div>
    				                    </td>
    				                </tr>
    				            </table>
    				        </div>
    				        <div v-else style="padding:20px;color:#909399;text-align:center;">暂无组长审核数据</div>
    				    </el-tab-pane>
    				    <el-tab-pane label="主审" name="mopinions">
        				        <!--<div class="otheader">-->
                    <!--                <div class="othno">序号</div>-->
                    <!--                <div class="othleimu">审核类目</div>-->
                    <!--                <div class="othyaoqiu">审核标准</div>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div class="otno">1</div>-->
                    <!--                <div class="otleimu">工法名称</div>-->
                    <!--                <div class="otyaoqiu">内容名称是否一致，工法是否与过去批准工法相同</div>-->
                    <!--            </div>-->
                    <!--            <div class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea"  placeholder="请输入评审意见"  v-model="curObj.mainexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">2</div>-->
                    <!--                <div  class="otleimu">企业级工法审查</div>-->
                    <!--                <div  class="otyaoqiu">审批部门原件审查，提供无争议证明</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"   class="otextarea"  placeholder="请输入评审意见"  v-model="opiniondata['enterprise_approval']"  v-model="curObj.mainexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--             <div class="otitem">-->
                    <!--                <div  class="otno">3</div>-->
                    <!--                <div  class="otleimu">工法主要完成单位及完成人审查</div>-->
                    <!--                <div  class="otyaoqiu">主要完成单位和主要完成人，必须是企业批准文件公布之列</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"  v-model="opiniondata['main_units_members']"  v-model="curObj.mainexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">4</div>-->
                    <!--                <div  class="otleimu">省外企业申报的工法审查</div>-->
                    <!--                <div  class="otyaoqiu">工程实例是否有贵州工程</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"  v-model="opiniondata['outside_province']"  v-model="curObj.mainexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">5</div>-->
                    <!--                <div  class="otleimu">关键技术鉴定证书审查、效益证明审查</div>-->
                    <!--                <div  class="otyaoqiu">专家委员会组成是否符合，证书内容是否齐全；效益证明是否有效真实</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"  v-model="opiniondata['key_certificates']"  v-model="curObj.mainexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">6</div>-->
                    <!--                <div  class="otleimu">工法名称与内容审查</div>-->
                    <!--                <div  class="otyaoqiu">名称与内容是否贴切，能否直观反映工法名称</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['name_content_match']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">7</div>-->
                    <!--                <div  class="otleimu">工法的叙述层次排列</div>-->
                    <!--                <div  class="otyaoqiu">工法是否按 章、节、条款、项、层次排列</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['hierarchy_order']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">8</div>-->
                    <!--                <div  class="otleimu">工法中表格、插图审查</div>-->
                    <!--                <div  class="otyaoqiu">表格、图应有名称，图表应有文字描述及编号</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"    class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['table_figures']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">9</div>-->
                    <!--                <div  class="otleimu">工法特点审查</div>-->
                    <!--                <div  class="otyaoqiu">使用功能或施工方法上的特点、先进性和创新性</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['features']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">10</div>-->
                    <!--                <div  class="otleimu">工法内容审查</div>-->
                    <!--                <div  class="otyaoqiu">材料与设备、质量安全、经济效益</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['content_items']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">11</div>-->
                    <!--                <div  class="otleimu">适用范围审查</div>-->
                    <!--                <div  class="otyaoqiu">采用该工法的工程对象或工程部位</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['scope']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">12</div>-->
                    <!--                <div  class="otleimu">环保节能审查</div>-->
                    <!--                <div  class="otyaoqiu">环保节能措施及效果</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea"  placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['environment']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">13</div>-->
                    <!--                <div  class="otleimu">工艺原理审查</div>-->
                    <!--                <div  class="otyaoqiu">关键技术基本原理是什么？特点是什么？其安全性和可靠性</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['principle']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">14</div>-->
                    <!--                <div  class="otleimu">应用实例</div>-->
                    <!--                <div  class="otyaoqiu">工程名称、合同、鉴定或提供成熟可靠性证书</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['cases']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">15</div>-->
                    <!--                <div  class="otleimu">工艺流程及操作要求审查</div>-->
                    <!--                <div  class="otyaoqiu">讲清基本工艺过程、工序衔接；工艺水平达到什么程度</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"    v-model="curObj.mainexpert['checked_opinions']['process_req']" disabled="true"></el-input>-->
                    <!--            </div>-->
                                
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">16</div>-->
                    <!--                <div  class="otleimu">工艺流程及操作要点阐述全面，工序衔接合理，该施工技术达到省内领先水平</div>-->
                    <!--                <div  class="otyaoqiu">关键技术证明：（专利号、专利权人）</div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['process_keypoints']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">17</div>-->
                    <!--                <div  class="otleimu">工法关键技术水平?</div>-->
                    <!--                <div  class="otyaoqiu"> </div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['key_tech_level']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">18</div>-->
                    <!--                <div  class="otleimu">是否适用于省内工程?</div>-->
                    <!--                <div  class="otyaoqiu"> </div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"  v-model="curObj.mainexpert['checked_opinions']['suitable_in_province']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">19</div>-->
                    <!--                <div  class="otleimu">是否同意推荐为省级工法?</div>-->
                    <!--                <div  class="otyaoqiu"> </div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['recommend_provincial']" disabled="true"></el-input>-->
                    <!--            </div>-->
                    <!--            <div class="otitem">-->
                    <!--                <div  class="otno">20</div>-->
                    <!--                <div  class="otleimu">不通过的充分理由（如同意可忽略）?</div>-->
                    <!--                <div  class="otyaoqiu"> </div>-->
                    <!--            </div>-->
                    <!--            <div  class="otinput">-->
                    <!--                <el-input type="textarea"  :rows="2" class="otextarea" placeholder="请输入评审意见"   v-model="curObj.mainexpert['checked_opinions']['rejection_reason']" disabled="true"></el-input>-->
                    <!--            </div>-->
            				<review-opinion-sheet @opinionsave="opinionsave"  :initial="curObj.mainexpert.checked_opinions"    :award_log_id = "id"  :is_view = "is_opinion_view"  />

        				    </el-tab-pane>
        				    <el-tab-pane label="副审" name="reopinions">
        				            <review-opinion-sheet @opinionsave="opinionsave"  :initial="curObj.reexpert.checked_opinions"    :award_log_id = "id"  :is_view = "is_opinion_view"  />

        				         <!--<div class="otheader">-->
                     <!--               <div class="othno">序号</div>-->
                     <!--               <div class="othleimu">审核类目</div>-->
                     <!--               <div class="othyaoqiu">审核标准</div>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div class="otno">1</div>-->
                     <!--               <div class="otleimu">工法名称</div>-->
                     <!--               <div class="otyaoqiu">内容名称是否一致，工法是否与过去批准工法相同</div>-->
                     <!--           </div>-->
                     <!--           <div class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea"  placeholder="请输入评审意见"  v-model="curObj.reexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">2</div>-->
                     <!--               <div  class="otleimu">企业级工法审查</div>-->
                     <!--               <div  class="otyaoqiu">审批部门原件审查，提供无争议证明</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"   class="otextarea"  placeholder="请输入评审意见"  v-model="opiniondata['enterprise_approval']"  v-model="curObj.reexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--            <div class="otitem">-->
                     <!--               <div  class="otno">3</div>-->
                     <!--               <div  class="otleimu">工法主要完成单位及完成人审查</div>-->
                     <!--               <div  class="otyaoqiu">主要完成单位和主要完成人，必须是企业批准文件公布之列</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"  v-model="opiniondata['main_units_members']"  v-model="curObj.reexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">4</div>-->
                     <!--               <div  class="otleimu">省外企业申报的工法审查</div>-->
                     <!--               <div  class="otyaoqiu">工程实例是否有贵州工程</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"  v-model="opiniondata['outside_province']"  v-model="curObj.reexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">5</div>-->
                     <!--               <div  class="otleimu">关键技术鉴定证书审查、效益证明审查</div>-->
                     <!--               <div  class="otyaoqiu">专家委员会组成是否符合，证书内容是否齐全；效益证明是否有效真实</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"  v-model="opiniondata['key_certificates']"  v-model="curObj.reexpert['checked_opinions']['name_match']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">6</div>-->
                     <!--               <div  class="otleimu">工法名称与内容审查</div>-->
                     <!--               <div  class="otyaoqiu">名称与内容是否贴切，能否直观反映工法名称</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['name_content_match']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">7</div>-->
                     <!--               <div  class="otleimu">工法的叙述层次排列</div>-->
                     <!--               <div  class="otyaoqiu">工法是否按 章、节、条款、项、层次排列</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['hierarchy_order']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">8</div>-->
                     <!--               <div  class="otleimu">工法中表格、插图审查</div>-->
                     <!--               <div  class="otyaoqiu">表格、图应有名称，图表应有文字描述及编号</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"    class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['table_figures']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">9</div>-->
                     <!--               <div  class="otleimu">工法特点审查</div>-->
                     <!--               <div  class="otyaoqiu">使用功能或施工方法上的特点、先进性和创新性</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['features']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">10</div>-->
                     <!--               <div  class="otleimu">工法内容审查</div>-->
                     <!--               <div  class="otyaoqiu">材料与设备、质量安全、经济效益</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['content_items']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">11</div>-->
                     <!--               <div  class="otleimu">适用范围审查</div>-->
                     <!--               <div  class="otyaoqiu">采用该工法的工程对象或工程部位</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['scope']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">12</div>-->
                     <!--               <div  class="otleimu">环保节能审查</div>-->
                     <!--               <div  class="otyaoqiu">环保节能措施及效果</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea"  placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['environment']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">13</div>-->
                     <!--               <div  class="otleimu">工艺原理审查</div>-->
                     <!--               <div  class="otyaoqiu">关键技术基本原理是什么？特点是什么？其安全性和可靠性</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['principle']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">14</div>-->
                     <!--               <div  class="otleimu">应用实例</div>-->
                     <!--               <div  class="otyaoqiu">工程名称、合同、鉴定或提供成熟可靠性证书</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['cases']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">15</div>-->
                     <!--               <div  class="otleimu">工艺流程及操作要求审查</div>-->
                     <!--               <div  class="otyaoqiu">讲清基本工艺过程、工序衔接；工艺水平达到什么程度</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"    v-model="curObj.reexpert['checked_opinions']['process_req']" disabled="true"></el-input>-->
                     <!--           </div>-->
                                
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">16</div>-->
                     <!--               <div  class="otleimu">工艺流程及操作要点阐述全面，工序衔接合理，该施工技术达到省内领先水平</div>-->
                     <!--               <div  class="otyaoqiu">关键技术证明：（专利号、专利权人）</div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['process_keypoints']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">17</div>-->
                     <!--               <div  class="otleimu">工法关键技术水平?</div>-->
                     <!--               <div  class="otyaoqiu"> </div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['key_tech_level']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">18</div>-->
                     <!--               <div  class="otleimu">是否适用于省内工程?</div>-->
                     <!--               <div  class="otyaoqiu"> </div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"  class="otextarea" placeholder="请输入评审意见"  v-model="curObj.reexpert['checked_opinions']['suitable_in_province']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">19</div>-->
                     <!--               <div  class="otleimu">是否同意推荐为省级工法?</div>-->
                     <!--               <div  class="otyaoqiu"> </div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea" :rows="2"   class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['recommend_provincial']" disabled="true"></el-input>-->
                     <!--           </div>-->
                     <!--           <div class="otitem">-->
                     <!--               <div  class="otno">20</div>-->
                     <!--               <div  class="otleimu">不通过的充分理由（如同意可忽略）?</div>-->
                     <!--               <div  class="otyaoqiu"> </div>-->
                     <!--           </div>-->
                     <!--           <div  class="otinput">-->
                     <!--               <el-input type="textarea"  :rows="2" class="otextarea" placeholder="请输入评审意见"   v-model="curObj.reexpert['checked_opinions']['rejection_reason']" disabled="true"></el-input>-->
                     <!--           </div>-->
            				    
        				    </el-tab-pane>
        				    
        				</el-tabs>
				        
				        
				        
				    			<!--<el-tabs style="" v-model="activeopinion" tab-position="top">-->
				    			<!--    <el-tab-pane label="主审审核意见" name="mopinions">-->
				    			<!--        <el-table-->
           <!--                                 :data="mainopiniondata"-->
           <!--                                 border-->
           <!--                                 style="width: 100%"-->
           <!--                                 :span-method="spanMethod"-->
           <!--                                 :cell-style="cellStyle"-->
           <!--                                 :header-cell-style="headerCellStyle"-->
           <!--                               >-->
           <!--                                 <el-table-column prop="project"  label="审查项目"  width="120"/>-->
           <!--                                 <el-table-column prop="category" label="审核类别"  width="200"/>-->
           <!--                                 <el-table-column prop="standard" label="审查标准"  min-width="360"/>-->
           <!--                                 <el-table-column prop="content"  label="评审内容"  min-width="360"/>-->
           <!--                               </el-table>-->
                                          
				    			<!--    </el-tab-pane>-->
				    			<!--    <el-tab-pane label="副审审核意见" name="reopinions">-->
				    			<!--        <el-table-->
           <!--                                 :data="reopiniondata"-->
           <!--                                 border-->
           <!--                                 style="width: 100%"-->
           <!--                                 :span-method="spanMethod"-->
           <!--                                 :cell-style="cellStyle"-->
           <!--                                 :header-cell-style="headerCellStyle"-->
           <!--                               >-->
           <!--                                 <el-table-column prop="project"  label="审查项目"  width="120"/>-->
           <!--                                 <el-table-column prop="category" label="审核类别"  width="200"/>-->
           <!--                                 <el-table-column prop="standard" label="审查标准"  min-width="360"/>-->
           <!--                                 <el-table-column prop="content"  label="评审内容"  min-width="360">-->
           <!--                                     <el-button  size="mini" type="success" icon="el-icon-check" @click="handleViewOpinion(scope.row)">查看内容</el-button>-->
           <!--                                 </el-table-column>-->
           <!--                               </el-table>-->
                                          
				    			<!--    </el-tab-pane>-->
				    			    
           <!--                     </el-tabs>-->
                    <el-dialog title="评审内容" :visible.sync="dialogOpinionVisible" width="874px" >
                        <div class="form_right">
                            <div class="form_1">
                                <div class="form_box_content">
                                    <div class="flex">
                                        <div class="my_form2">
                                            <div class="form_title" style="" v-if="nrow.project != undefined">审查项目</div>
                                            <div class="form_content"  v-if="nrow.project != undefined">
                                                {{nrow.project}}
                                            </div>
                                            <div class="form_title" style="" v-if="nrow.category != undefined">审核类别</div>
                                            <div class="form_long" v-if="nrow.category != undefined">
                                                {{nrow.category}}
                                            </div>
                                            <div class="form_title" style="" v-if="nrow.standard != undefined">审查标准</div>
                                            <div class="form_long"  v-if="nrow.standard != undefined">
                                                {{nrow.standard}}
                                            </div>
                                            <div class="form_title" style="">评审内容</div>
                                            <div class="form_long">
                                                {{nrow.content}}
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </el-dialog>
                    
				</el-tab-pane>
				<el-tab-pane label="审核日志" name="four">
					<el-table :data="visibleCheckedlogs"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" :cell-style="{'text-align':'center'}">
						
						<el-table-column :show-overflow-tooltip="true" prop="no" label="序号" min-width="60"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="dept" label="所属部门" min-width="110"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="checker" label="处理人" min-width="90"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="action" label="动作" min-width="80"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="step" label="当前节点" min-width="130"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="checkedAt" label="处理时间" min-width="140"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" label="处理意见" min-width="180">
							<template slot-scope="scope"><div>{{ getCheckedlogOpinionDisplay(scope.row) }}</div></template>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="nstep" label="下一个节点" min-width="130"></el-table-column>
					</el-table>
					
					<el-dialog title="驳回理由" :visible.sync="dialogRejectVisible" width="874px">
					    <div class="checkeddiv">
                            <div class="ctitle">处理人</div>
                            <div class="cval">{{nlog.checker}}</div>
                            <el-divider></el-divider>
                            <div class="ctitle">驳回理由</div>
                            <div class="cval">{{nlog.checkedRemark}}</div>
                        </div>
                        
                        <!--<div class="form_right">-->
                        <!--    <div class="form_1">-->
                        <!--        <div class="form_box_content">-->
                        <!--            <div class="flex">-->
                        <!--                <div class="my_form2">-->
                        <!--                    <div class="form_title" style="" >处理人</div>-->
                        <!--                    <div class="form_content">-->
                        <!--                        {{nlog.checker}}-->
                        <!--                    </div>-->
                        <!--                    <div class="form_title" style="" >驳回理由</div>-->
                        <!--                    <div class="form_long" >-->
                        <!--                        {{nlog.checkedRemark}}-->
                        <!--                    </div>-->
                        <!--                </div>-->
                        <!--            </div>-->
                                    
                        <!--        </div>-->
                        <!--    </div>-->
                        <!--</div>-->
                    </el-dialog>
                    
                   
                    
                    
				</el-tab-pane>
				
				
			</el-tabs>
			
		</div>
		
        <!-- start 不通过 start-->
            <el-dialog title="请选择驳回项目并附上驳回理由" :visible.sync="dialogVisible" width="774px" :before-close="handleClose">
                <div class="checkeddiv">
                    <div class="ctitle">驳回选择</div>
                    <div class="cval">
                        <el-radio-group v-model="reject" >
                            <el-radio :label="7">打回企业修正</el-radio>
                            <el-radio :label="6">不通过</el-radio>
                          </el-radio-group>
                    </div>
                    
                    <div class="ctitle">驳回理由</div>
                    <div class="cval">
                        <div  style="border-bottom:1px solid #DDDDDD;width:100%;padding-bottom:10px;" v-if="reject == 6">
                              <el-checkbox-group v-model="reject_agreement">
                                <el-checkbox label="main">同意主审意见</el-checkbox>
                                <el-checkbox label="second">同意副审意见</el-checkbox>>
                              </el-checkbox-group>
                              <div style="margin-top:10px;">
                                <el-button size="mini" type="primary" plain @click="syncLeaderRejectReason">同步主副审不推荐意见</el-button>
                                <el-button size="mini" plain @click="clearLeaderRejectReason">一键清空</el-button>
                              </div>
                        </div>
                        <textarea class="reason" name="" id="" cols="30" rows="10" maxlength="500" v-model="reason"
                          placeholder="点击输入无法通过审核的原因..."></textarea>
                    </div>
                </div>
                <el-tabs style="" v-model="rejecttab" tab-position="top" v-if="reject == 7">
				    <el-tab-pane label="工法信息" name="rinfo">
				        <el-table :data="rinfos"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;"  row-key='id'  :cell-style="{'text-align':'center'}" @selection-change="handleRejectInfoChange">
                            <el-table-column
                              type="selection"
                              width="55">
                            </el-table-column>
        					<el-table-column prop="name" label="填写项" min-width="80">
                            </el-table-column>
                            <el-table-column  prop="value" label="填写内容" show-overflow-tooltip min-width="160">
                            </el-table-column>
        				</el-table>
				    </el-tab-pane>
				    <el-tab-pane label="文件" name="rfile">
				        <el-table :data="rfiles"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" row-key='id' :cell-style="{'text-align':'center'}" @selection-change="handleRejectFileChange">
                            <el-table-column
                              type="selection"
                              width="55">
                            </el-table-column>
        					<el-table-column prop="no" label="序号" min-width="80">
                            </el-table-column>
                            <el-table-column  prop="name" label="文件" show-overflow-tooltip min-width="160">
                            </el-table-column>
        				</el-table>
				    </el-tab-pane>
				    
				</el-tabs>
                <span slot="footer" class="dialog-footer" style="margin:0 auto;text-align:center;">
                        <el-button type="default"  @click="dialogVisible = false" style="margin-right:20px;">取消</el-button>
    					<el-button type="primary"  @click="rejectsumbit">确认提交</el-button>
    				</span>
            </el-dialog>
            <el-dialog title="退回初审" :visible.sync="returnInitialVisible" width="520px" :before-close="handleReturnInitialClose">
                <el-form label-width="90px" size="small">
                    <el-form-item label="退回专家" required>
                        <el-checkbox-group v-model="returnInitialExperts">
                            <el-checkbox label="main">主审专家</el-checkbox>
                            <el-checkbox label="second">副审专家</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="退回理由">
                        <el-input
                            type="textarea"
                            :rows="5"
                            maxlength="500"
                            show-word-limit
                            v-model="returnInitialReason"
                            placeholder="可选，填写退回初审说明">
                        </el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="margin:0 auto;text-align:center;">
                    <el-button type="default" @click="handleReturnInitialClose" style="margin-right:20px;">取消</el-button>
                    <el-button type="primary" @click="submitReturnInitial">确认退回</el-button>
                </span>
            </el-dialog>
            <el-dialog title="组长审核结果" :visible.sync="leaderResultVisible" width="480px">
                <table v-if="leaderResultRow" style="width:100%;border-collapse:collapse;font-size:14px;text-align:left;">
                    <tr>
                        <td style="width:50%;padding:10px 14px;border:1px solid #E4E7ED;color:#7C828A;white-space:nowrap;">组长审核结果：</td>
                        <td style="width:50%;padding:10px 14px;border:1px solid #E4E7ED;"
                            :style="{color: getReviewResultColor(leaderResultRow.leader_checked_status), fontWeight:'600'}">
                            {{ getReviewResultText(leaderResultRow.leader_checked_status) }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" style="padding:10px 14px;border:1px solid #E4E7ED;line-height:1.8;">
                            <div style="color:#7C828A;margin-bottom:6px;">组长审核意见：</div>
                            <div style="color:#303133;white-space:pre-wrap;">{{ (leaderResultRow.leader && leaderResultRow.leader.content) || '暂无意见' }}</div>
                        </td>
                    </tr>
                </table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="leaderResultVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
            <el-dialog title="短信通知失败原因" :visible.sync="smsFailVisible" width="480px">
                <div v-if="smsFailInfo" style="font-size:14px;line-height:1.9;color:#303133;">
                    <p>因【{{ getSmsFailReason(smsFailInfo.fail_reason) }}】，短信通知失败。</p>
                    <p style="color:#E6A23C;margin-top:8px;">如通知失败非企业停机、空号、暂停服务、关机、不在服务区的原因造成，请及时联系告知评审办公室。</p>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="smsFailVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
            <el-dialog title="终审结果" :visible.sync="finalResultVisible" width="460px">
                <div v-if="finalResultRow">
                    <table style="width:100%;border-collapse:collapse;text-align:center;font-size:14px;">
                        <tr style="background:#F5F7FA;">
                            <td style="padding:10px 0;border:1px solid #E4E7ED;color:#7C828A;">主审审核结果</td>
                            <td style="padding:10px 0;border:1px solid #E4E7ED;color:#7C828A;">副审审核结果</td>
                            <td style="padding:10px 0;border:1px solid #E4E7ED;color:#7C828A;">组长审核结果</td>
                        </tr>
                        <tr>
                            <td style="padding:12px 0;border:1px solid #E4E7ED;"
                                :style="{color: getReviewResultColor(finalResultRow.primary_checked_status)}">
                                {{ getReviewResultText(finalResultRow.primary_checked_status) }}
                            </td>
                            <td style="padding:12px 0;border:1px solid #E4E7ED;"
                                :style="{color: getReviewResultColor(finalResultRow.secondary_checked_status)}">
                                {{ getReviewResultText(finalResultRow.secondary_checked_status) }}
                            </td>
                            <td style="padding:12px 0;border:1px solid #E4E7ED;"
                                :style="{color: getReviewResultColor(finalResultRow.leader_checked_status)}">
                                {{ getReviewResultText(finalResultRow.leader_checked_status) }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding:14px 0;border:1px solid #E4E7ED;font-size:15px;">
                                终审结果：
                                <span :style="{color: finalResultRow.status == 5 ? '#67C23A' : '#F56C6C', fontWeight:'600'}">
                                    {{ finalResultRow.status == 5 ? '通过' : '不通过' }}
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="finalResultVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
            <el-dialog title="终审结果" :visible.sync="finalReviewVisible" width="420px" :close-on-click-modal="false" :show-close="false">
                <div style="padding:0 10px;">
                    <div style="display:flex;align-items:center;gap:24px;font-size:14px;margin-bottom:16px;">
                        <span style="color:#303133;white-space:nowrap;">终审结果：</span>
                        <el-radio-group v-model="finalReviewResult" style="display:flex;gap:24px;">
                            <el-radio label="5">通过</el-radio>
                            <el-radio label="6">不通过</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if="finalReviewResult === '6'" style="margin-bottom:16px;">
                        <div style="font-size:13px;color:#606266;margin-bottom:6px;">不通过原因 <span style="color:#F56C6C;">*</span></div>
                        <el-input
                            v-model="finalReviewRejectReason"
                            type="textarea"
                            :rows="4"
                            maxlength="500"
                            show-word-limit
                            placeholder="请填写不通过原因"/>
                    </div>
                    <div style="text-align:center;margin-top:8px;">
                        <el-button @click="finalReviewVisible=false;finalReviewResult='';finalReviewRejectReason=''">取消</el-button>
                        <el-button type="primary" @click="submitFinalReview" style="margin-left:16px;">提交审核</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog title="预审核退回" :visible.sync="adminRejectVisible" width="480px" :close-on-click-modal="false">
                <el-form label-width="80px" size="small">
                    <el-form-item label="退回原因" required>
                        <el-input
                            type="textarea"
                            :rows="5"
                            maxlength="500"
                            show-word-limit
                            v-model="adminRejectReason"
                            placeholder="请填写退回原因">
                        </el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="adminRejectVisible = false; adminRejectReason = ''">取消</el-button>
                    <el-button type="warning" @click="submitAdminReject">确认退回</el-button>
                </span>
            </el-dialog>
             <el-dialog title="驳回理由" :visible.sync="dialogTableVisible">
              <div class="checkeddiv" v-if="nlog.checker != undefined">
                    <div class="ctitle">处理人</div>
                    <div class="cval">{{nlog.checker}}</div>
                    <el-divider></el-divider>
                    <div class="ctitle">驳回理由</div>
                    <div class="cval">{{nlog.checkedRemark}}</div>
                </div>
                <el-tabs style="" v-model="nmr" tab-position="top" v-if="nlog">
				    <el-tab-pane label="工法信息" name="mrinfo">
				        <el-table v-if="nlog.need_modify_remark" :data="nlog.need_modify_remark.info"
    						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
    						style="width: 100%;" :cell-style="{'text-align':'center'}">
            					<el-table-column :show-overflow-tooltip="true" prop="name" label="填写项" min-width="80">
                                </el-table-column>
                                <el-table-column :show-overflow-tooltip="true" prop="value" label="填写内容" show-overflow-tooltip min-width="160">
                                </el-table-column>
            				</el-table>
        			</el-tab-pane>
				    <el-tab-pane label="文件" name="mrfile">
				        <el-table v-if="nlog.need_modify_remark" :data="nlog.need_modify_remark.files"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" :cell-style="{'text-align':'center'}">
        					<el-table-column :show-overflow-tooltip="true" prop="name" label="上传项" min-width="80">
                            </el-table-column>
                            <el-table-column :show-overflow-tooltip="true"  label="文件" show-overflow-tooltip min-width="160">
                                <template slot-scope="scope">
    							    <a class="a01" :href="scope.row.url" target="_blank">查看</a>
    							</template>
                            </el-table-column>
        				</el-table>
				    </el-tab-pane>
            				    
				</el-tabs>
            </el-dialog>
            
        <!--    <el-dialog title="修订意见" :visible.sync="dialogaModifyVisible" width="774px" :before-close="handleUnitClose">-->
                
        <!--        <span slot="footer" class="dialog-footer" style="margin:0 auto;text-align:center;">-->
    				<!--	<el-button type="primary"  @click="dialogaModifyVisible = false">确认提交</el-button>-->
    				<!--</span>-->
        <!--    </el-dialog>-->
        
         <!-- start 驳回修订 start-->
        <!-- start 驳回修订 end-->
        
        
    <!--    <el-dialog title="填写不通过原因" :visible.sync="dialogVisible" width="774px" :before-close="handleClose">-->
    <!--        <div class="yellow-box">-->
    <!--            <span>{{ user.legal_representative_id }}</span>-->
    <!--            <span>{{ user.name }}</span>-->
    <!--            <span>申请提交于{{ created_at }}</span>-->
    <!--        </div>-->
    <!--        <textarea class="reason" name="" id="" cols="30" rows="10" maxlength="500" v-model="reason"-->
    <!--                  placeholder="点击输入无法通过审核的原因..."></textarea>-->
    <!--        <span slot="footer" class="dialog-footer">-->
				<!--	<el-button type="primary" icon="el-icon-check" @click="sumbit">确认提交</el-button>-->
				<!--</span>-->
    <!--    </el-dialog>-->
	</div>
</template>

<script>
	import AllHeader from "@/components/Modal/AllHeader";
	import Pagetion from "@/components/Modal/Pagetion";
	import groupAwardDetail from './applyAward/groupAwardDetail'
	import assignZjGroupDialog from './applyAward/assignZjGroupDialog'
	import ReviewOpinionSheet from '@/components/ReviewOpinionSheet.vue';
		import {
			expertaward, //专家端审核奖项列表=
			expertverify, //专家端审核是否通过
	        getExpert,
            getBatchWtypeExperts,
	        setExpert,//设置专家
	       AwardBatches,
	       checkedlogs,
       expertgfbverify,
       returnInitialReview,
       batchExportScore,
       exportScoreByBatch,
       exportSummaryByBatch,
       adminRejectAwardLog,
       exportOpinionPdfs
	} from "../utils/api.js";
	export default {
		components: {
			AllHeader,
			Pagetion,
			groupAwardDetail,
			assignZjGroupDialog,
			ReviewOpinionSheet
		},
		data() {
			return {
                loading:true,
                download:false,
				dialogVisible: false,
                dialogUnitVisible: false,
                dialogTableVisible:false,
                dialogZJVisible:false,
				step: 0,
                timeRange: '',
                exportType:1,
				ischage: false,
				lable: "材料列表",
				pageSize: 10,
				total: 0,
				awardList: [],
				sublabel: "返回列表",
				subtitle: "", //副标题
				formlist: [],
				temformlist: [],
                detailSummary: null,
				temUnitlist:[],//参加单位信息
				temFilelist:[],//申报登记表需补充内容
                temRecommandlist:[],//推荐表
                temSupplementlist:[],
                zjlist:[],
                zjId:[],
                unit:{},//参加单位信息
				user: {},
				id: '',
				reason: "",
				year: null,
				activeName: "first",
				parameters:{"Contractorinfo":{},"SupplementaryContent":{}},
                searchField:'unit',
                keyword:'',
                searchYear:'',
                searchstatus:'1',
                award_id:0,
				curObj: {}, // 当前点击的行
				isShowAssignGroup: false,
				reAssign: false,
                batches:[],
                checkedlogs:[],
                created_at:'',
                award_batch_id:0,
                activestatus:2,
                activewtype:"房屋建筑工程",
                astatus:'',
                reviewStatus:'',
                wtype:'',
                dates:null,
	                tableFilters:{
	                    table_status:'',
	                    mainexpert:'',
	                    reexpert:'',
	                    primary_result:'',
	                    secondary_result:'',
	                    leader_result:'',
	                    final_result:'',
	                },
	                mainExpertFilterOptions: [],
	                reExpertFilterOptions: [],
	                mainopiniondata:[],
                reopiniondata:[],
                projectSpan: [],
                dialogOpinionVisible:false,
                nrow : {},
                dialogRejectVisible:false, //显示驳回理由
                nlog:{},
                reject:0, //驳回类型
        		reason:'', //驳回原因
        		rejecttab:'rinfo', //驳回标签
        		rinfos:[],
        		rfiles:[],
        		rselectedinfos:[],
        		rselectedfiles:[],
        		reject_agreement:[],
        		activeopinion:'leader',
        		nmr:'mrinfo',
        		selected_log_ids:[],
        		rejectbatch :0,
        		tsort:'',
        		bname:'',
				is_opinion_view:1,
				returnInitialVisible:false,
				returnInitialReason:'',
				returnInitialExperts:[],
				returnInitialRow:null,
				rejectRow:null,
				adminRejectVisible:false,
				adminRejectReason:'',
				adminRejectRow:null,
				leaderResultVisible:false,
				leaderResultRow:null,
				finalReviewVisible:false,
				finalReviewResult:'',
				finalReviewRejectReason:'',
				finalReviewRow:null,
				smsFailVisible:false,
				smsFailInfo:null,
				finalResultVisible:false,
				finalResultRow:null
			};
		},
		mounted() {
			this.token = "Bearer " + localStorage.getItem("TOKEN");
			var zj_id = localStorage.getItem("zj_id");
			console.log("获取zjinfo",zj_id);
			this.searchYear = this.award_batch_id = this.$route.query.award_batch_id;
			this.bname = this.$route.query.bname;
			console.log("award_batch_id",this.award_batch_id);

			if(this.award_batch_id && this.award_batch_id != undefined) {
			    localStorage.setItem('gfaward_batch_id',this.award_batch_id);
			} else {
			    this.searchYear = this.award_batch_id = localStorage.getItem('gfaward_batch_id');
			    
			    console.log("gfaward_batch_id 1",this.award_batch_id);
			}
			
			console.log("gfaward_batch_id",localStorage.getItem('gfaward_batch_id'));

			
			if(zj_id){
				this.award_id = zj_id;
			}
			if(this.award_id == 17){
				this.searchstatus = '3';
			}
            this.getBatches();
			
		},
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 250) + 'px'; //自定义高度需求
            },
            visibleCheckedlogs() {
                return this.filterCheckedlogsForLeader(this.checkedlogs)
            },
			isGroupAward() {
				return this.formlist.some(item => item.award_id === 17)
			},
            searchPlaceholder() {
                const placeholderMap = {
                    unit: '请输入单位名称',
                    name: '请输入工法名称',
                    author: '请输入工法完成人',
                    no: '请输入序号',
                }
                return placeholderMap[this.searchField] || '请输入搜索内容'
			}
        },
		methods: {
			getFileUrls(row) {
				if (Array.isArray(row && row.urls) && row.urls.length) return row.urls;
				return row && row.url ? [{ url: row.url, name: row.name }] : [];
			},
			formatFileLinkLabel(file, index) {
				const value = `${(file && file.name) || ''} ${(file && file.url) || ''}`.toLowerCase();
				const type = /\.(mp4|avi|flv)(?:$|[?#])/.test(value) ? '视频' : '文件';
				return `${type}${index + 1}`;
			},
		     opinionsave(payload){
		    },
            getRowInfo(row){
                return row && row.content && row.content.info ? row.content.info : {}
            },
            getRegisterProvince(row){
                const info = this.getRowInfo(row)
                return info.gf_province_detail
                    || row.register_province
                    || info.register_province
                    || (Number(info.gf_province || row.gf_province) === 1 ? '贵州省' : '-')
            },
            formatAuthorNames(row){
                const info = this.getRowInfo(row)
                const authors = Array.isArray(info.author_names)
                    ? info.author_names
                    : (info.author_names ? [info.author_names] : [])
                const names = authors
                    .map((author) => author && author.name)
                    .filter(Boolean)
                return names.length ? names.join('、') : '-'
            },
		    getLogRole(row){
		        if(!row){
		            return ''
		        }
		        const role = row.role || row.expert_role || row.reviewer_role || row.checker_role
		        if(role){
		            return String(role)
		        }
		        const isLeader = Number(row.is_leader || row.expert_is_leader || row.checked_is_leader || 0)
		        if(isLeader === 1){
		            return 'leader'
		        }
		        if(isLeader === 2){
		            return 'main'
		        }
		        if(isLeader === 3){
		            return 'second'
		        }
		        return ''
		    },
		    isAdminLog(row){
		        return Number(row && (row.is_leader || row.expert_is_leader || row.checked_is_leader || 0)) === 4
		    },
		    getCheckedlogOpinionDisplay(row){
		        if(!row){
		            return ''
		        }
		        const status = Number(row.checked_status)
		        const reason = row.checkedRemark || row.reject_reason || row.reason || ''
		        const role = this.getLogRole(row)
		        let text = row.checkedStatus || ''
		        if(role === 'main' || role === 'second' || role === 'leader'){
		            if(status === 1){
		                text = '推荐'
		            }else if(status === 2){
		                text = '不推荐'
		            }
		        }else if(this.isAdminLog(row)){
		            if(status === 1){
		                text = '通过'
		            }else if(status === 2){
		                text = '不通过'
		            }
		        }
		        if(reason && text && text.indexOf(reason) === -1){
		            return `${text}：${reason}`
		        }
		        return text
		    },
		    normalizeCheckedlog(row){
		        const map = {
		            submit: '企业提交',
		            withdraw: '企业自主撤回修改',
		            admin_return: '管理员退回',
		            resubmit: '企业重新提交',
		            auto_submit: '超期自动提交',
		            expert_return: '专家退回',
		            timeout_terminated: '逾期终止',
		            initial_review: '初审',
		            leader_review: '组长中审',
		            return_initial: '组长退回初审',
		            final_review: '管理员终审',
		        }
		        const action = row.action_type || row.log_type || row.event_type
		        if(action && map[action]){
		            return Object.assign({}, row, {
		                step: row.step || map[action],
		                checkedStatus: row.checkedStatus || row.checked_status_text || map[action],
		                checkedRemark: row.checkedRemark || row.reject_reason || row.remark || row.reason || '',
		            })
		        }
		        return row
		    },
		    filterCheckedlogsForLeader(logs){
		        if(!Array.isArray(logs)){
		            return []
		        }
		        return logs
		            .map(this.normalizeCheckedlog)
		            .filter(row => {
		                const role = this.getLogRole(row)
		                return !role || ['leader', 'main', 'second'].indexOf(role) !== -1
		            })
		    },
		    toBatch(){
		          this.$router.push(`/gfprize/Awardbatchcgf`)
		    },
		    toOpinion(id,award_log_id){
		        //let token = 'Bearer ' + localStorage.getItem('TOKEN');
                let url = `${window.location.protocol}//${window.location.host}/user/#/ginfo?id=${id}&aid=${award_log_id}`;
                window.open(url)
                
		        //this.$router.push(`/user/#/ginfo?id=${id}&aid=${award_log_id}`)
		    },
		   handleSortChange({ prop, order }) {
		       this.tsort = prop+' '+order;
            //   this.sortOptions.prop = prop; // 设置当前排序字段和顺序
            //   this.sortOptions.order = order; // ascending or descending order based on event parameter. 默认情况下，Element UI 会传递这两个参数。你可以根据需要调整这部分代码。例如，如果你的数据已经是升序或降序，你可能需要根据实际情况调整
              console.log('prop',prop);
              console.log('order',order);
              this.initList(1);
		   },
		    normalizeStatus(value){
		        return Number(value || 0);
		    },
		    getMainReview(row){
		        return row && row.mainexpert ? row.mainexpert : {};
		    },
		    getSecondReview(row){
		        return row && row.reexpert ? row.reexpert : {};
		    },
		    isExpertReviewFinished(record){
		        const status = this.normalizeStatus(record && record.status);
		        return status === 1 || status === 2 || status === 5 || status === 6;
		    },
		    isInitialReviewComplete(row){
		        return this.isExpertReviewFinished(this.getMainReview(row)) && this.isExpertReviewFinished(this.getSecondReview(row));
		    },
		    isLeaderBlocked(row){
		        if(!row){
		            return true;
		        }
		        const status = this.normalizeStatus(row.status);
		        return status === 5 || status === 6 || status === 7 || status === 8 || row.is_returned == 1 || row.return_type === 'enterprise' || row.return_type === 'initial';
		    },
		    canLeaderReview(row){
		        return row && this.normalizeStatus(row.status) === 3 && this.isInitialReviewComplete(row) && !this.isLeaderBlocked(row);
		    },
		    canLeaderReturnInitial(row){
		        return this.canLeaderReview(row);
		    },
		    canSelectForLeaderBatch(row){
		        return !!row;
		    },
		    getLeaderReviewStatusText(row){
		        if(!row){
		            return '-';
		        }
		        const status = this.normalizeStatus(row.status);
		        if(status === 5){
		            return '已推荐';
		        }
		        if(status === 6){
		            return '不推荐';
		        }
		        if(status === 7){
		            return '退回企业';
		        }
		        if(row.return_type === 'initial'){
		            return '已退回初审';
		        }
		        if(!this.isInitialReviewComplete(row)){
		            return '初审中';
		        }
		        if(status === 4){
		            return '待中审';
		        }
		        return '等待审核';
		    },
		    getLeaderReviewStatusType(row){
		        const text = this.getLeaderReviewStatusText(row);
		        if(text === '待中审'){
		            return 'warning';
		        }
		        if(text === '已推荐'){
		            return 'success';
		        }
		        if(text === '不推荐' || text === '退回企业' || text === '已退回初审'){
		            return 'danger';
		        }
		        return 'info';
		    },
		    getReviewOpinionText(record){
		        if(!record){
		            return '';
		        }
		        const opinion = record.checked_opinions || record.opinion || record.review_opinion || {};
		        return opinion.rejection_reason || opinion.reject_reason || opinion.reason || record.reject_reason || record.checkedRemark || '';
		    },
		    syncLeaderRejectReason(){
		        if(!this.rejectRow){
		            this.$message.warning('请先选择审核记录');
		            return;
		        }
		        const parts = [];
		        const mainText = this.getReviewOpinionText(this.getMainReview(this.rejectRow));
		        const secondText = this.getReviewOpinionText(this.getSecondReview(this.rejectRow));
		        if(mainText){
		            parts.push('主审意见：' + mainText);
		        }
		        if(secondText){
		            parts.push('副审意见：' + secondText);
		        }
		        if(parts.length === 0){
		            this.$message.warning('暂无可同步的主副审不推荐意见');
		            return;
		        }
		        this.reason = parts.join('\n');
		    },
		    clearLeaderRejectReason(){
		        this.reason = '';
		        this.reject_agreement = [];
		    },
		    handleBatchChecked(type){
		        if(this.selected_log_ids.length == 0){
		            this.$message.error('请选择评审记录')
    				return false
		        }
		        const selectedRows = this.formlist.filter(item => this.selected_log_ids.indexOf(item.id) !== -1);
		        const invalidRows = selectedRows.filter(item => Number(item.status) !== 4);
		        if(invalidRows.length > 0){
		            this.$message.error('仅待终审的记录可批量操作');
		            return false;
		        }
		        if(type === 'reject'){
		            this.$confirm("确认批量终审不通过？")
		                .then((_) => {
		                    expertgfbverify({ status: 6 }, this.selected_log_ids.join(',')).then(res => {
		                        this.$message({ message: '操作成功', type: 'success' });
		                        this.initList(1);
		                        this.getvalue();
		                    }).catch(error => {
		                        this.$message({ message: error, type: 'warning' });
		                    });
		                })
		                .catch((_) => {});
		        } else {
                    this.$confirm("确认批量终审通过？")
                        .then((_) => {
                            expertgfbverify({ status: 5 }, this.selected_log_ids.join(',')).then(res => {
                                this.$message({
                                    message: "审核成功",
                                    type: "success",
                                })
                                this.initList(1);
                                this.getvalue();
                            }).catch(error => {
                                this.$message({
                                    message: error,
                                    type: "warning",
                                })
                            })
                        })
                        .catch((_) => {});
		        }
		    },
		    getDownloadFileName(response, fallback){
		        const headers = response && response.headers ? response.headers : {}
		        const disposition = headers['content-disposition'] || headers['Content-Disposition'] || ''
		        const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition)
		        if(match){
		            return decodeURIComponent(match[1] || match[2])
		        }
		        return fallback
		    },
		    saveBlobResponse(response, fallback){
		        const blob = response.data instanceof Blob ? response.data : new Blob([response.data])
		        const url = window.URL.createObjectURL(blob)
		        const link = document.createElement('a')
		        link.href = url
		        link.download = this.getDownloadFileName(response, fallback)
		        document.body.appendChild(link)
		        link.click()
		        document.body.removeChild(link)
		        window.URL.revokeObjectURL(url)
		    },
		    batchExportSelectedScore(){
		        if(this.selected_log_ids.length === 0){
		            this.$message.error('请选择要导出的记录')
		            return false
		        }
		        batchExportScore(this.selected_log_ids).then(response => {
		            this.saveBlobResponse(response, '工法专家评审表.xlsx')
		            this.$message.success('导出成功')
		        }).catch(error => {
		            this.$message({
		                message: error && error.message ? error.message : error,
		                type: 'warning'
		            })
		        })
		    },
		    
		    handleSelectionChange(selection){
		       this.selected_log_ids = selection.map(item => item.id); // 获取所有选中行的 ID 数组
                console.log(this.selected_log_ids); // 
		    },
		    //驳回
		    handleReject(index, row){
		        if(!this.canLeaderReview(row)){
		            this.$message.warning('初审未完成的记录不可中审');
		            return false;
		        }
		        this.id = row.id
		        this.rejectRow = row;
		        this.reject = 6;
		        this.reason = '';
		        this.rejecttab = 'rinfo';
		        var info = row.content.info;
		        //组装工本信息
		        var author_names = info['author_names'].map(item => item['name']);
		        this.rinfos = [
		            {'name':'工程类别','value':info['type_of_work'],'id':'type_of_work'},
		            {'name':'专业分类','value':info['type_of_work'],'id':'type_of_major'},
		            {'name':'工法名称','value':info['name'],'id':'name'},
		            {'name':'联系人及电话','value':info['username']+'/'+info['phone'],'id':'contact'},
		            {'name':'编写单位','value':info['unit'],'id':'unit'},
		            {'name':'完成人','value':author_names.join(','),'id':'author_names'},
		            {'name':'电话','value':info['tel'],'id':'tel'}
		            ];
		        //组装文件
		        this.rfiles = [
		            {'name':'贵州省级工法申报汇总表(附件2)','id':'filelist1','no':1},
		            {'name':'贵州省级工法申报表（附件1）','id':'filelist3' ,'no':2},
		            {'name':'工法文本','id':'filelist4' ,'no':3},
		            {'name':'企业工法证明材料','id':'filelist5' ,'no':4},
		            {'name':'工法关键技术鉴定的有关资料','id':'filelist6' ,'no':5},
		            {'name':'工程应用证明','id':'filelist7' ,'no':6},
		            {'name':'经济效益证明','id':'filelist8' ,'no':7},
		            {'name':'科技查新报告','id':'filelist9' ,'no':8},
		            {'name':'涉及他方专利的无争议声明书','id':'filelist10' ,'no':9},
		            {'name':'关键技术标准、专利证书、科技成果获奖证明等其他有关材料','id':'filelist11' ,'no':10}
		            
		            ];
		        this.rselectedfiles = [];
		        this.rselectedinfos = [];
		        this.dialogVisible = true;
		    },
		    openReturnInitialDialog(row){
		        if(!this.canLeaderReturnInitial(row)){
		            this.$message.warning('仅初审完成且待中审的记录可退回初审');
		            return false;
		        }
		        this.returnInitialRow = row;
		        this.returnInitialReason = '';
		        this.returnInitialExperts = [];
		        if(row.mainexpert){
		            this.returnInitialExperts.push('main');
		        }
		        if(row.reexpert){
		            this.returnInitialExperts.push('second');
		        }
		        this.returnInitialVisible = true;
		    },
		    handleReturnInitialClose(){
		        this.returnInitialVisible = false;
		        this.returnInitialReason = '';
		        this.returnInitialExperts = [];
		        this.returnInitialRow = null;
		    },
		    submitReturnInitial(){
		        if(!this.returnInitialRow){
		            this.$message.error('请选择退回记录');
		            return false;
		        }
		        if(this.returnInitialExperts.length === 0){
		            this.$message.error('请选择退回专家');
		            return false;
		        }
		        const data = {
		            experts: this.returnInitialExperts,
		            reject_reason: this.returnInitialReason || '',
		            award_batch_id: this.award_batch_id
		        };
		        returnInitialReview(this.returnInitialRow.id, data).then(res => {
		            this.$message({
		                message: '退回初审成功',
		                type: 'success'
		            });
		            this.handleReturnInitialClose();
		            this.initList(1);
		            this.getvalue();
		        }).catch(error => {
		            this.$message({
		                message: error,
		                type: 'warning'
		            });
		        });
		    },
		    openSmsFailDialog(info){
		        this.smsFailInfo = info;
		        this.smsFailVisible = true;
		    },
		    getSmsFailReason(failReason){
		        if(!failReason) return '未知原因';
		        const parts = failReason.split(':');
		        return parts.length > 1 ? parts.slice(1).join(':').trim() : failReason.trim();
		    },
		    openFinalResultDialog(row){
		        this.finalResultRow = row;
		        this.finalResultVisible = true;
		    },
		    openFinalReviewDialog(row){
		        this.finalReviewRow = row;
		        this.finalReviewResult = '';
		        this.finalReviewRejectReason = '';
		        this.finalReviewVisible = true;
		    },
		    submitFinalReview(){
		        if(!this.finalReviewResult){
		            this.$message.error('请选择终审结果');
		            return;
		        }
		        if(this.finalReviewResult === '6' && !String(this.finalReviewRejectReason || '').trim()){
		            this.$message.error('请填写不通过原因');
		            return;
		        }
		        const payload = { status: Number(this.finalReviewResult) };
		        if(this.finalReviewResult === '6'){
		            payload.reject_reason = String(this.finalReviewRejectReason).trim();
		        }
		        expertgfbverify(payload, String(this.finalReviewRow.id)).then(res => {
		            this.$message({ message: '审核成功', type: 'success' });
		            this.finalReviewVisible = false;
		            this.finalReviewRejectReason = '';
		            this.initList(1);
		            this.getvalue();
		            this.step = 0;
		        }).catch(error => {
		            this.$message({ message: error || '操作失败', type: 'warning' });
		        });
		    },
		    openLeaderResultDialog(row){
		        if(!row.leader || row.leader_checked_status === 0) return;
		        this.leaderResultRow = row;
		        this.leaderResultVisible = true;
		    },
		    getExpertResultLogId(row, role){
		        if(!row || !Array.isArray(row.checkedlogs)){
		            return null;
		        }
		        const target = role === 'main' ? row.mainexpert : row.reexpert;
		        if(!target){
		            return null;
		        }
		        const checkerId = Number(target.expert_id || (target.expert && target.expert.id) || 0);
		        const isLeader = role === 'main' ? 2 : 3;
		        if(!checkerId){
		            return null;
		        }
		        const matched = row.checkedlogs
		            .filter(log => Number(log.checker_id) === checkerId && Number(log.is_leader) === isLeader)
		            .sort((a, b) => Number(b.id || 0) - Number(a.id || 0))[0];
		        return matched ? matched.id : null;
		    },
		    openExpertDetail(row, role){
		        const checkedLogId = this.getExpertResultLogId(row, role);
		        if(!checkedLogId){
		            this.$message.warning('未找到对应的审核结果记录');
		            return;
		        }
		        window.open('/user/#/ginfo?id=' + checkedLogId + '&aid=' + row.id);
		    },
		    openAdminRejectDialog(row){
		        this.adminRejectRow = row;
		        this.adminRejectReason = '';
		        this.adminRejectVisible = true;
		    },
		    submitAdminReject(){
		        if(!this.adminRejectReason || !this.adminRejectReason.trim()){
		            this.$message.error('请填写退回原因');
		            return;
		        }
		        adminRejectAwardLog(this.adminRejectRow.id, { reject_reason: this.adminRejectReason }).then(res => {
		            this.$message({ message: '退回成功', type: 'success' });
		            this.adminRejectVisible = false;
		            this.adminRejectReason = '';
		            this.adminRejectRow = null;
		            this.initList(1);
		        }).catch(error => {
		            this.$message({ message: error || '操作失败', type: 'warning' });
		        });
		    },
		    handleRejectFileChange(files){
		        this.rselectedfiles = files;
		    },
		    handleRejectInfoChange(infos){
		        this.rselectedinfos = infos;
		    },
		    handleViewOpinion(row){
		       this.dialogOpinionVisible = true;
		       this.nrow = row;  
		    },
		    downloadSummaryTable(){
                exportSummaryByBatch(this.award_batch_id, this.activewtype).then(response => {
                    this.saveBlobResponse(response, '工法评审汇总表.xlsx')
                    this.$message.success('导出成功')
                }).catch(error => {
                    this.$message({ message: error && error.message ? error.message : error, type: 'warning' })
                })
		    },
		    downloadReviewTable(){
                if(this.selected_log_ids.length === 0){
                    this.$message.error('请先勾选要导出的记录')
                    return
                }
                const isSingle = this.selected_log_ids.length === 1
                const filename = isSingle ? '工法专家评审表.pdf' : '工法专家评审表.zip'
                exportOpinionPdfs(this.selected_log_ids).then(response => {
                    this.saveBlobResponse(response, filename)
                    this.$message.success('导出成功')
                }).catch(error => {
                    this.$message({ message: error && error.message ? error.message : error, type: 'warning' })
                })
            },
		    downloadReviewTableLegacy(){
                exportScoreByBatch(this.award_batch_id, this.activewtype).then(response => {
                    this.saveBlobResponse(response, '工法专家评审表.xlsx')
                    this.$message.success('导出成功')
                }).catch(error => {
                    this.$message({ message: error && error.message ? error.message : error, type: 'warning' })
                })
		    },
		    handlecstatus(){
		       this.initList(1);  
		    },
            async handlewtype(){
               this.tableFilters.mainexpert = '';
               this.tableFilters.reexpert = '';
               this.$nextTick(() => {
                    if (this.$refs.awardTable && this.$refs.awardTable.clearFilter) {
                        this.$refs.awardTable.clearFilter('mainexpert');
                        this.$refs.awardTable.clearFilter('reexpert');
                    }
               });
               await this.loadExpertFilterOptions();
		       this.initList(1);  
            },
            handleTableFilterChange(filters){
                const pick = (key) => {
                    const value = filters && filters[key];
                    return Array.isArray(value) && value.length ? value[0] : '';
                };
                this.tableFilters = {
                    table_status: pick('table_status'),
                    mainexpert: pick('mainexpert'),
                    reexpert: pick('reexpert'),
                    primary_result: pick('primary_result'),
                    secondary_result: pick('secondary_result'),
                    leader_result: pick('leader_result'),
                    final_result: pick('final_result'),
                };
                this.initList(1);
            },
		     handleBatch(){
		        localStorage.setItem('gfaward_batch_id',this.award_batch_id);
		        this.initList(1);
		    },
			async getBatches(){
                let res = await AwardBatches(this.award_id);
                this.batches = res;
                console.log('res.data',this.batches)
                if(this.searchYear == '' ){
                    this.award_batch_id = this.searchYear = this.batches.length ? this.batches[0]['id'] : '';
                    localStorage.setItem('gfaward_batch_id',this.award_batch_id);
                }
                await this.loadExpertFilterOptions();
                this.initList(1);
            },
            async loadExpertFilterOptions(){
                if (!this.award_batch_id || !this.activewtype) {
                    this.mainExpertFilterOptions = [];
                    this.reExpertFilterOptions = [];
                    return;
                }
                try {
                    const experts = await getBatchWtypeExperts(this.award_batch_id, { wtype: this.activewtype });
                    const options = (experts || []).map(item => ({
                        text: item.name,
                        value: item.id,
                    }));
                    this.mainExpertFilterOptions = options;
                    this.reExpertFilterOptions = options;
                } catch (e) {
                    this.mainExpertFilterOptions = [];
                    this.reExpertFilterOptions = [];
                }
            },
            buildExpertFilterOptionsFromRows(rows){
                const mainMap = new Map();
                const reMap = new Map();
                (Array.isArray(rows) ? rows : []).forEach((row) => {
                    const main = row && row.mainexpert && row.mainexpert.expert;
                    const re = row && row.reexpert && row.reexpert.expert;
                    if (main && main.id && main.name && !mainMap.has(main.id)) {
                        mainMap.set(main.id, { text: main.name, value: main.id });
                    }
                    if (re && re.id && re.name && !reMap.has(re.id)) {
                        reMap.set(re.id, { text: re.name, value: re.id });
                    }
                });
                return {
                    main: Array.from(mainMap.values()),
                    re: Array.from(reMap.values()),
                };
            },
            syncExpertFilterOptionsFromRows(rows){
                const fallback = this.buildExpertFilterOptionsFromRows(rows);
                if (!this.mainExpertFilterOptions.length) {
                    this.mainExpertFilterOptions = fallback.main;
                }
                if (!this.reExpertFilterOptions.length) {
                    this.reExpertFilterOptions = fallback.re;
                }
            },
		    getStatusText(status){
		        const statusMap = {
		            1: '待分配',
		            2: '初审中',
		            3: '待中审',
		            4: '待终审',
		            5: '终审通过',
		            6: '终审不通过',
		            7: '已退回',
		            8: '已退回',
		            9: '超时终止'
		        }
		        return statusMap[status] || '未知状态'
		    },
            getStatusFilterOptions(){
                const values = Number(this.activestatus) === 3 ? [5, 6] : [1, 2, 3, 4, 7, 8, 9];
                return values.map(value => ({
                    text: this.getStatusText(value),
                    value,
                }));
            },
		    getStatusColor(status){
		        const colorMap = {
		            1: '#194ABE',
		            2: '#E6A23C',
		            3: '#194ABE',
		            4: '#194ABE',
		            5: '#67C23A',
		            6: '#E6A23C',
		            7: '#595959',
		            8: '#595959',
		            9: '#FF6B09'
		        }
		        return colorMap[status] || '#909399'
		    },
            getExpertResultFilterOptions(){
                return [
                    { text: '待审核', value: 0 },
                    { text: '推荐', value: 1 },
                    { text: '不推荐', value: 2 },
                    { text: '等待重新提交', value: 3 },
                ];
            },
		    getReviewResultText(checked_status){
		        const statusMap = {
		            0: '待审核',
		            1: '推荐',
		            2: '不推荐',
		            3: '等待重新提交'
		        }
		        return statusMap[checked_status] || '-'
		    },
            getFinalResultFilterOptions(){
                return [
                    { text: '通过', value: 5 },
                    { text: '不通过', value: 6 },
                ];
            },
		    getReviewResultColor(checked_status){
		        const colorMap = {
		            0: '#194ABE',
		            1: '#67C23A',
		            2: '#F56C6C',
		            3: '#E6A23C'
		        }
		        return colorMap[checked_status] || '#194ABE'
		    },
		    getOperationText(row){
		        const status = Number(row.status);
		        if(status === 2 || status === 3) return '数据审核中';
		        if(status === 7 || status === 8) return '等待企业修改';
		        if(status === 4) return '审核';
		        if(status === 5 || status === 6 || status === 9) return '查阅';
		        return '';
		    },

			//分页
			getIndex($index) {
			    return $index + 1;
			},
			getpageValue(index) {
				this.initList(index);
			},
            downloadClick(type){
                this.exportType = type;
                this.timeRange = '';
                this.download = true;
            },
            exportInfo(){
                 let url = `${window.location.protocol}//${window.location.host}/api/home/review/award_log/export/9?token=${this.token}`;
                 if (this.timeRange) {
                     url = url + '&start_time='+this.dateFormat(this.timeRange[0],'yyyy-MM-dd') + '&end_time=' + this.dateFormat(this.timeRange[1],'yyyy-MM-dd');
                 }
                 url += '&type='+this.exportType;
                 console.log(url)
                 window.open(url);
            },
            handleUnitClose(done) {
                var that = this;
                this.$confirm("确认关闭？")
					.then((_) => {
						done();
						that.dialogaModifyVisible = false;
					})
					.catch((_) => {});
            },
			handleClose(done) {
				this.$confirm("确认关闭？")
					.then((_) => {
						done();
					})
					.catch((_) => {});
			},
			//1 提交 待分配 //2 初审 // 3 组长 //4 终审 //5 通过 6 不通过 7 驳回修改
			async initList(page) {
			    this.loading = true;
				const reviewStatusMap = {
                    '待分配': 1,
                    '待初审': 2,
                    '待中审': 3,
                    '待终审': 4,
                    '已退回': 7,
                    '超时终止': 9,
                };
                let statusParam;
                if (this.reviewStatus && reviewStatusMap[this.reviewStatus] !== undefined) {
                    statusParam = reviewStatusMap[this.reviewStatus];
                } else if (Number(this.activestatus) === 3) {
                    statusParam = '5,6';
                } else {
                    statusParam = '1,2,3,4,7,8,9';
                }
				const data = {
					pageSize: this.pageSize,
					page: page,
					award_id: this.award_id,
					award_batch_id: this.award_batch_id,
					status: statusParam,
					astatus: this.astatus,
					wtype:this.activewtype,
					dates:this.dates
				};
                if(this.tableFilters.table_status !== ''){
                    data.table_status = this.tableFilters.table_status;
                }
                if(this.tableFilters.mainexpert !== ''){
                    data.mainexpert = this.tableFilters.mainexpert;
                }
                if(this.tableFilters.reexpert !== ''){
                    data.reexpert = this.tableFilters.reexpert;
                }
                if(this.tableFilters.primary_result !== ''){
                    data.primary_result = this.tableFilters.primary_result;
                }
                if(this.tableFilters.secondary_result !== ''){
                    data.secondary_result = this.tableFilters.secondary_result;
                }
                if(this.tableFilters.leader_result !== ''){
                    data.leader_result = this.tableFilters.leader_result;
                }
                if(this.tableFilters.final_result !== ''){
                    data.final_result = this.tableFilters.final_result;
                }
				this.formlist =  [];
                if(this.searchYear){
                    data.year = this.searchYear;
                }
                if(this.searchField){
                    data.searchField = this.searchField;
                }
                if(this.keyword){
                    data.keyword = this.keyword;
                }
                if(this.tsort ){
                    data.tsort = this.tsort;
                }
				let res = await expertaward(data);
                this.loading = false;
				this.formlist = res.data || [];
				this.formlist.forEach(e => {
					let year = e.created_at.slice(0, 4);
					e.year = e.award_batch.year+'-'+e.award_batch.batch;//(parseInt(year) - 1) + '-' + year;
                    if(e.award_id!=9||e.no==0){
                        e.no = e.id;
                    }
				})
                this.syncExpertFilterOptionsFromRows(this.formlist);
				this.total = res.total;
                console.log(this.formlist);
			},
			getvalue() {
				this.step = 0;
				this.ischage = false;
				this.subtitle = "";
                this.detailSummary = null;
			},
			getapply(obj = {}, config = {}) {
                console.log(obj,'getapply');
				this.reAssign = config.reAssign || false
				if (obj.award && obj.award.title === '工程建设质量管理小组竞赛活动') {
					this.curObj = obj
					this.isShowAssignGroup = true
					return
				}
                this.dialogZJVisible = true;
                this.zjId = [];
                this.id = obj.id;
                getExpert().then(res => {
                    this.zjlist = res;
                })
			},
			toShowRejectRemark(row){
			    this.nlog = row;
			    this.dialogRejectVisible = true;
			    
			     //this.$message.error(row.checkedRemark);
			},
			toShowModify(row){
			    this.nlog = row;
			    this.dialogTableVisible = true;
			},
            submitZJ(){
              //提交庄家
                let data = {
                    expert_ids:this.zjId
                }
                if(this.zjId.length<=0){
                    this.$message.error('请选择专家');
                    return;
                }

                setExpert(this.id,data).then(res => {
                    this.$message({
                        message: "保存成功",
                        type: "success",
                    })
                    this.zjId = [];
                    this.dialogZJVisible = false;
                    this.initList(1);
                    this.getvalue();
                }).catch(error => {
					this.$message({
						message: error,
						type: "warning",
					})
				});
            },
			async toDetail(obj) {
				console.log(obj)
                this.id = obj.id;
				this.parameters = obj.content || {}
				const { award } = obj
				this.temformlist = [obj];
				this.ischage = true;
				this.curObj = obj
                this.temSupplementlist = [];
                this.temUnitlist = [];
                
                this.loading = true;
                console.log('this.parameters.info', this.parameters && this.parameters.info ? this.parameters.info : null)
                const info = this.parameters.info || {};
                const authorNames = obj.author_names_text || (Array.isArray(info.author_names)
                    ? info.author_names.map((author) => author && author.name).filter(Boolean).join('、')
                    : '');
                this.detailSummary = {
                    id: obj.id,
                    no: obj.no,
                    unit: info.unit || '-',
                    register_province: this.getRegisterProvince(obj),
                    type_of_work: info.type_of_work || '-',
                    name: info.name || '-',
                    author_names: authorNames || '-',
                    created_at: obj.created_at || '-',
                    status: obj.status,
                };
                console.log('[Awardgfreview][detailSummary][2026-06-29-v2]', {
                    id: this.detailSummary.id,
                    no: this.detailSummary.no,
                    unit: this.detailSummary.unit,
                    type_of_work: this.detailSummary.type_of_work,
                    name: this.detailSummary.name,
                    author_names: this.detailSummary.author_names,
                    created_at: this.detailSummary.created_at,
                    status: this.detailSummary.status,
                });
                const safeUrl = (list) => (list && list[0] && list[0]['url']) ? list[0]['url'] : '';
                const mediaUrls = (list) => (Array.isArray(list) ? list : (list ? [list] : []))
                    .map(file => ({ url: file && file.url, name: file && file.name }))
                    .filter(file => file.url);
                const pushFile = (name, url, urls = []) => {
                    this.temUnitlist.push({ name, url, urls });
                };
                pushFile('《贵州省工程建设工法申报表》', safeUrl(info.filelist3));
                pushFile('工法申报承诺书', safeUrl(info.filelist_commitment));
                pushFile('完整工法文本', safeUrl(info.filelist4));
                pushFile('企业级工法批准发布文件', safeUrl(info.filelist5));
                pushFile('关键技术专家论证材料', safeUrl(info.filelist6));
                pushFile('工程应用证明材料', safeUrl(info.filelist7));
                pushFile('经济效益证明', safeUrl(info.filelist8));
                pushFile('工法现场应用照片不少于 10张，可附短视频资料', safeUrl(info.filelist12), mediaUrls(info.filelist12));
                pushFile('科技查新报告', safeUrl(info.filelist9));
                pushFile('涉及第三方专利的提交无争议声明', safeUrl(info.filelist10));
                pushFile('专利证书、成果获奖等其他佐证材料', safeUrl(info.filelist11));
                pushFile('贵州省工程建设工法申报汇总表', safeUrl(info.filelist1));
                pushFile('贵州省建设工法申报汇总表xlsx版', safeUrl(info.filelist2));
                
                let tmainopiniondata = obj.primary_checked_opinions == null ? obj.mainexpert.checked_opinions : obj.primary_checked_opinions;
                console.log('tmainopiniondata',tmainopiniondata)
                this.mainopiniondata = [
                        // —— 申报条件审查 —— //
                        { type:'normal', project:'申报条件审查', category:'工法名称', standard:'内容名称是否一致，工法是否与过去批准工法相同', content:tmainopiniondata['name_match'] },
                        { type:'normal', project:'申报条件审查', category:'企业级工法审查', standard:'审批部门原件审查，提供无争议证明', content:tmainopiniondata['enterprise_approval'] },
                        { type:'normal', project:'申报条件审查', category:'工法主要完成单位及完成人审查', standard:'主要完成单位和主要完成人，必须是企业批准文件公布之列。', content:tmainopiniondata['main_units_members'] },
                        { type:'normal', project:'申报条件审查', category:'省外企业申报的工法审查', standard:'工程实例是否有贵州工程', content:tmainopiniondata['outside_province'] },
                        { type:'normal', project:'申报条件审查', category:'关键技术鉴定证书审查、效益证明审查', standard:'专家委员会组成是否符合，证书内容是否齐全；效益证明是否有效真实', content:tmainopiniondata['key_certificates'] },
                
                        // —— 工法文本审查 —— //
                        { type:'normal', project:'工法文本审查', category:'工法名称与内容审查', standard:'名称与内容是否贴切，能否直观反映工法名称', content:tmainopiniondata['name_content_match'] },
                        { type:'normal', project:'工法文本审查', category:'工法的叙述层次排列', standard:'工法是否按 章、节、条款、项、层次排列', content:tmainopiniondata['hierarchy_order'] },
                        { type:'normal', project:'工法文本审查', category:'工法中表格、插图审查', standard:'表格、图应有名称，图表应有文字描述及编号', content:tmainopiniondata['table_figures'] },
                        { type:'normal', project:'工法文本审查', category:'工法特点审查', standard:'使用功能或施工方法上的特点、先进性和创新性', content:tmainopiniondata['features'] },
                
                        // —— 编写内容审查 —— //
                        { type:'normal', project:'编写内容审查', category:'工法内容审查', standard:'材料与设备、质量安全、经济效益', content:tmainopiniondata['content_items'] },
                        { type:'normal', project:'编写内容审查', category:'适用范围审查', standard:'采用该工法的工程对象或工程部位', content:tmainopiniondata['scope'] },
                        { type:'normal', project:'编写内容审查', category:'环保节能审查', standard:'环保节能措施及效果', content:tmainopiniondata['environment'] },
                        { type:'normal', project:'编写内容审查', category:'工艺原理审查', standard:'关键技术基本原理是什么？特点是什么？其安全性和可靠性？', content:tmainopiniondata['principle'] },
                        { type:'normal', project:'编写内容审查', category:'应用实例', standard:'工程名称、合同、鉴定或提供成熟可靠性证书', content:tmainopiniondata['cases'] },
                        { type:'normal', project:'编写内容审查', category:'工艺流程及操作要求审查', standard:'讲清基本工艺过程、工序衔接；工艺水平达到什么程度', content:tmainopiniondata['process_req'] },
                        { type:'normal', project:'编写内容审查', category:'工艺流程及操作要点阐述全面，工序衔接合理，该施工技术达到省内领先水平', standard:'关键技术证明：（专利号、专利权人）', content:tmainopiniondata['process_keypoints'] },
                
                        // —— 整行说明 / 问答 —— //
                        { type:'full', fullLabel:'审查人意见' },
                        { type:'full', fullLabel:'工法关键技术水平？', content:tmainopiniondata['key_tech_level'] },
                        { type:'full', fullLabel:'是否适用于省内工程？' , content:tmainopiniondata['suitable_in_province']},
                        { type:'full', fullLabel:'是否同意推荐为省级工法？', content:tmainopiniondata['recommend_provincial'] }, // 空白行（可去掉）
                        { type:'full', fullLabel:'不通过的充分理由（如同意可忽略）', content:tmainopiniondata['rejection_reason'] },
                      ];
                      
                let treopiniondata = obj.secondary_checked_options == null ? obj.reexpert.checked_opinions : obj.secondary_checked_options;
                                                     console.log('treopiniondata',treopiniondata)

                this.reopiniondata = [
                        // —— 申报条件审查 —— //
                        { type:'normal', project:'申报条件审查', category:'工法名称', standard:'内容名称是否一致，工法是否与过去批准工法相同', content:treopiniondata['name_match'] },
                        { type:'normal', project:'申报条件审查', category:'企业级工法审查', standard:'审批部门原件审查，提供无争议证明', content:treopiniondata['enterprise_approval'] },
                        { type:'normal', project:'申报条件审查', category:'工法主要完成单位及完成人审查', standard:'主要完成单位和主要完成人，必须是企业批准文件公布之列。', content:treopiniondata['main_units_members'] },
                        { type:'normal', project:'申报条件审查', category:'省外企业申报的工法审查', standard:'工程实例是否有贵州工程', content:treopiniondata['outside_province'] },
                        { type:'normal', project:'申报条件审查', category:'关键技术鉴定证书审查、效益证明审查', standard:'专家委员会组成是否符合，证书内容是否齐全；效益证明是否有效真实', content:treopiniondata['key_certificates'] },
                
                        // —— 工法文本审查 —— //
                        { type:'normal', project:'工法文本审查', category:'工法名称与内容审查', standard:'名称与内容是否贴切，能否直观反映工法名称', content:treopiniondata['name_content_match'] },
                        { type:'normal', project:'工法文本审查', category:'工法的叙述层次排列', standard:'工法是否按 章、节、条款、项、层次排列', content:treopiniondata['hierarchy_order'] },
                        { type:'normal', project:'工法文本审查', category:'工法中表格、插图审查', standard:'表格、图应有名称，图表应有文字描述及编号', content:treopiniondata['table_figures'] },
                        { type:'normal', project:'工法文本审查', category:'工法特点审查', standard:'使用功能或施工方法上的特点、先进性和创新性', content:treopiniondata['features'] },
                
                        // —— 编写内容审查 —— //
                        { type:'normal', project:'编写内容审查', category:'工法内容审查', standard:'材料与设备、质量安全、经济效益', content:treopiniondata['content_items'] },
                        { type:'normal', project:'编写内容审查', category:'适用范围审查', standard:'采用该工法的工程对象或工程部位', content:treopiniondata['scope'] },
                        { type:'normal', project:'编写内容审查', category:'环保节能审查', standard:'环保节能措施及效果', content:treopiniondata['environment'] },
                        { type:'normal', project:'编写内容审查', category:'工艺原理审查', standard:'关键技术基本原理是什么？特点是什么？其安全性和可靠性？', content:treopiniondata['principle'] },
                        { type:'normal', project:'编写内容审查', category:'应用实例', standard:'工程名称、合同、鉴定或提供成熟可靠性证书', content:treopiniondata['cases'] },
                        { type:'normal', project:'编写内容审查', category:'工艺流程及操作要求审查', standard:'讲清基本工艺过程、工序衔接；工艺水平达到什么程度', content:treopiniondata['process_req'] },
                        { type:'normal', project:'编写内容审查', category:'工艺流程及操作要点阐述全面，工序衔接合理，该施工技术达到省内领先水平', standard:'关键技术证明：（专利号、专利权人）', content:treopiniondata['process_keypoints'] },
                
                        // —— 整行说明 / 问答 —— //
                        { type:'full', fullLabel:'审查人意见' },
                        { type:'full', fullLabel:'工法关键技术水平？', content:treopiniondata['key_tech_level'] },
                        { type:'full', fullLabel:'是否适用于省内工程？' , content:treopiniondata['suitable_in_province']},
                        { type:'full', fullLabel:'是否同意推荐为省级工法？', content:treopiniondata['recommend_provincial'] }, // 空白行（可去掉）
                        { type:'full', fullLabel:'不通过的充分理由（如同意可忽略）', content:treopiniondata['rejection_reason'] },
                      ];

                //var checkedlogs = await checkedlogs(this.id);
                //this.temSupplementlist = [];
                this.checkedlogs = await checkedlogs(obj.id);
				this.step = 1;
				 this.loading = false;

			},
            toUnitDetail(obj){
                console.log(obj,'toUnitDetail')
                this.unit = obj;
                this.dialogUnitVisible = true;
            },
			//通过
			handleEdit(a, b) {
			    if(!this.canLeaderReview(b)){
			        this.$message.warning('初审未完成的记录不可中审');
			        return false;
			    }
				console.log(a, b);
				let data = {
					status: 5
				}
                this.$confirm("确认通过？")
                    .then((_) => {
                        expertverify(data, b.id).then(res => {
                            this.$message({
                                message: "审核成功",
                                type: "success",
                            })
                            this.initList(1);
                            this.getvalue();
                        }).catch(error => {
                            this.$message({
                                message: error,
                                type: "warning",
                            })
                        })
                    })
                    .catch((_) => {});
			},
			//立即提交
			rejectsumbit() {
			    if (this.reason == "") {
					this.$message.error('请填写驳回原因')
					return false
				}
				let data = {
					status: this.reject,
                    reject_reason: this.reason,
                    rinfos:this.rselectedinfos,
                    rfiles:this.rselectedfiles,
                    reject_agreement:this.reject_agreement
				}
				if(this.rejectbatch == 1){
				    expertgfbverify(data, this.selected_log_ids.join(',')).then(res => {
    					this.$message({
    						message: "提交成功",
    						type: "success",
    					})
                        this.reason = '';
                        this.dialogVisible = false;
                        this.initList(1);
                        this.getvalue();
                        this.reject_agreement = []
                        this.rejectbatch = 0;
    				}).catch(error => {
                        this.dialogVisible = false;
    					this.$message({
    						message: error,
    						type: "warning",
    					})
                        this.reason = '';
    				})
				} else {
				    expertverify(data, this.id).then(res => {
    					this.$message({
    						message: "提交成功",
    						type: "success",
    					})
                        this.reason = '';
                        this.dialogVisible = false;
                        this.initList(1);
                        this.getvalue();
                        this.reject_agreement = []
    				}).catch(error => {
                        this.dialogVisible = false;
    					this.$message({
    						message: error,
    						type: "warning",
    					})
                        this.reason = '';
    				})
				}
				
				
			},
			//不予通过
			handleDelete(a, b) {
				this.dialogVisible = true;
				this.user = b.user
				this.id = b.id
				this.created_at = b.created_at;
			},
            resetQuery() {
                this.searchYear = '';
                this.searchField = 'unit';
                this.keyword = '';
                this.award_id = 0;
                this.loading = true;
                this.initList(1);
            },
            handleQuery(){
                this.loading = true;
                this.initList(1);
            },
            dateFormat(date,fmt) {
                let ret
                const opt = {
                    'y+': date.getFullYear().toString(), // 年
                    'M+': (date.getMonth() + 1).toString(), // 月
                    'd+': date.getDate().toString(), // 日
                    'H+': date.getHours().toString(), // 时
                    'm+': date.getMinutes().toString(), // 分
                    's+': date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                }
                for (let k in opt) {
                    ret = new RegExp('(' + k + ')').exec(fmt)
                    if (ret) {
                        fmt = fmt.replace(
                            ret[1],
                            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
                        )
                    }
                }
                return fmt
            },
			viewRejectReason(row) {
				this.$alert(row.reject_reason, '驳回理由', {
					confirmButtonText: '确定'
				});
			},
			buildRowspanMap(list, key) {
              const span = []
              let i = 0
              while (i < list.length) {
                if (list[i].type !== 'normal') { // full 行：不参与纵向合并
                  span[i] = 1
                  i++
                  continue
                }
                let j = i + 1
                while (
                  j < list.length &&
                  list[j].type === 'normal' &&
                  list[j][key] === list[i][key]
                ) j++
                const len = j - i
                span[i] = len
                for (let k = i + 1; k < j; k++) span[k] = 0
                i = j
              }
              return span
            },
        
            // 合并规则
            spanMethod({ row, rowIndex, columnIndex }) {
              // 整行横跨：只显示第 0 列，其它列隐藏
              if (row.type === 'full') {
                if (columnIndex === 0) {
                  // 把“整行标题”放在第一列显示，其它列隐藏
                  row.project = row.fullLabel
                  row.category = ''
                  row.standard = ''
                  row.content  = ''
                  return { rowspan: 1, colspan: 4 }
                }
                return { rowspan: 0, colspan: 0 }
              }
        
              // 普通行合并“审查项目”（第 0 列）
              if (columnIndex === 0) {
                const rowspan = this.projectSpan[rowIndex]
                return { rowspan, colspan: rowspan > 0 ? 1 : 0 }
              }
        
              return { rowspan: 1, colspan: 1 }
            },
        
            // 样式
            cellStyle() {
              return {
                'white-space': 'normal',
                'word-break': 'break-all',
                'line-height': '20px',
                'padding': '8px 10px',
                'vertical-align': 'middle'
              }
            },
            headerCellStyle() {
              return { 'text-align': 'center', 'font-weight': '600' }
            }
		},
	};
</script>

<style>
	.el-tabs__header {
		width: 100% !important;
	}
    .divZJ{
        text-align: left;overflow:auto;
    }
</style>
<style lang="less" scoped>
.wtype-tabs {
    display: flex;
    align-items: center;
    gap: 30px;
    margin-top: 15px;
    margin-bottom: 15px;
    padding-left: 0;
}
.wtype-tab-item {
    font-size: 16px;
    color: #606266;
    cursor: pointer;
    padding-bottom: 8px;
    border-bottom: 2px solid transparent;
    &.active {
        color: #194ABE;
        font-weight: bold;
        border-bottom-color: #194ABE;
    }
    &:hover {
        color: #194ABE;
    }
}
.otheader{
    width:100%;
    font-size: 16px;
    color: #262626;
    text-align:center;
    display:flex;
    flex-direction:row;
    background: #F9FAFF;
    
}
.otitem {
    background: #F0F4FF;
    font-size: 14px;
    color: #262626;
    display: flex;
}
.othno, .otno {
    width:100px;
    text-align:center;
    padding-top:10px;
    padding-bottom:10px;
    border-right: 1px solid #DDDDDD;
}
.othleimu,.otleimu {
    width:200px;
    text-align:center;
     padding-top:10px;
    padding-bottom:10px;
    border-right: 1px solid #DDDDDD;
}
.othyaoqiu,.otyaoqiu {
    text-align:center;
    padding-top:10px;
    padding-bottom:10px;
    width:calc(100% - 300px);
}
.otinput .otextarea {
    width:100%;
}
.checkeddiv {
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #D9D9D9;
        padding:20px;
    }
    .ctitle {
        font-weight: 700;
        font-size: 16px;
        color: #262626;
        margin-bottom: 10px;
        text-align: left;
    }
    .cval {
        font-weight: 400;
        font-size: 18px;
        color: #262626;
        text-align: left;
        margin-bottom:20px;
    }
    
.binfobase .my_form2 {
    margin-bottom:0px !important;
    height: auto !important;
    margin-bottom: 0px !important;
    border-bottom: 1px solid #DDD;
     padding-top: 0px !important; 
     padding-bottom: 0px !important; 
    padding-left: 20px;
    
}
.binfobase .form_title {
    width: 150px !important;
        border-right: 1px solid #ddd;
    height: 50px !important;
    line-height: 50px  !important;
}
.binfobase .form_content {
        padding-left: 10px;
        height: 50px;
    line-height: 50px;
    width: calc(100% - 230px) !important;
        
}
.topnavs {
        position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    border-bottom: 1px solid #DDDDDD;
}
.checkeddiv {
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #D9D9D9;
        padding:20px;
    }
    .ctitle {
        font-weight: bold;
        font-size: 20px;
        color: #262626;
        margin-bottom:20px;
    }
    .cval {
        font-weight: 400;
        font-size: 18px;
        color: #262626;
        text-align: left;
        margin-bottom:20px;
    }
	/deep/.block-title {
		border-left: 3px solid #194abe !important;
	}

	.yellow-box {
		height: 40px;
		background: #FEF8EF;
		opacity: 1;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;

		span {
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			line-height: 24px;

			&:nth-child(1) {
				color: #194ABE;
			}

			&:nth-child(2) {
				color: #0C0D0F;
			}

			&:nth-child(3) {
				color: #7C828A;
				font-size: 14px;
			}
		}
	}

	.reason {
		margin-top: 20px;
		width: 100%;
		height: 162px;
		background: #FFFFFF;
		border: 1px solid #BDC3CB;
		opacity: 1;
		border-radius: 4px;
		outline: none;
		padding: 10px;
		box-sizing: border-box;
	}

	.textarea {
		width: 382px;
		// height: 92px;
		background: #ffffff;
		border: 1px solid #bdc3cb;
		opacity: 1;
		border-radius: 4px;
	}

	.block-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin: 20px 0;

		&-item {
			width: 370px;
			background: #ffffff;
			border: 1px dashed #c8cdd5;
			padding: 24px 25px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-bottom: 21px;
			position: relative;

			&-r-t {
				position: absolute;
				top: 0;
				right: 0;
				width: 73px;
				height: 27px;
				background: #f5f9fb;
				opacity: 1;
				border-radius: 0px 0px 0px 80px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				line-height: 27px;
				color: #c6c9ce;
				padding-left: 10px;
				box-sizing: border-box;
			}

			&-box {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				align-items: flex-start;

				&-t {
					width: 244px;
					color: #0c0d0f;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-align: justify;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
				}

				&-dtae {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					line-height: 26px;
					color: #194abe;
				}

				&-startend {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					line-height: 26px;
					color: #7c828a;
				}

				&-b {
					width: 91px;
					height: 32px;
					background: #ffffff;
					border: 1px solid #194abe;
					color: #194abe;
					opacity: 1;
					border-radius: 6px;
					text-align: center;
					line-height: 32px;
					font-size: 14px;
					cursor: pointer;
				}

				&-b-d {
					background: #ffffff !important;
					border: 1px solid #d4dbdd !important;
					color: #c8cdd5 !important;
				}

				&-b-s {
					background: #d4dbdd !important;
					border: 1px solid #d4dbdd !important;
					color: #ffffff !important;
				}
			}
		}
	}

	.margin-bottom-40 {
		margin-bottom: 40px;
	}

	.infor {
		padding-bottom: 40px;
		min-height: 800px;
		margin-bottom: 34px;
		position: relative;
	}

	.upload-demo {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.uploadheader {
		height: 60px;
		width: 100%;
		display: flex;
		align-items: center;

		span {
			margin-right: 10px;
			color: #71767c;
		}
	}

	.margin-top-40 {
		margin-top: 40px;
	}

	.block-solid {
		width: 100%;
		height: 2px;
		background-color: #e51725;
		margin-top: 30px;
	}

	.shenhjrkr {
		margin: 71px 0 100px 0;

		img {
			width: 120px;
		}
	}
	.block-addr {
		display: inline-block;
		padding: 13px 32px;
		background-color: #fff7e8;
		font-size: 14px;
		margin-top: 31px;

		.span-l {
			color: #9fa5ae;
		}

		.span-r {
			color: #194abe;
		}
	}
	.pform_title {
	    font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 700;
        line-height: 20px;
        color: #0c0d0f;
        text-align: left;
	}
	.form_right {
	      width: 860px;
	      .flex {
	        display: flex;
	      }
	      .flex-direction {
	        flex-direction: column;
	      }
	      .form_1 {
	        width: 100%;
	        background: #ffffff;
	        padding: 35px 30px;
	        box-sizing: border-box;
	        margin-bottom: 30px;
	        border-radius: 6px;

			.form_dec {
				text-align: left;
				margin-top: 20px;
			}

	        .border {
	          border-top: 1px dashed #9fa5ae;
	          margin: 20px 0;
	        }
	        .bord {
	          margin-top: 11px;
	          width: 858px;
	          height: 0px;
	          border: 1px solid #194abe;
	          position: relative;
	          img {
	            width: 11px;
	            height: 6px;
	            position: absolute;
	            top: -6px;
	            left: 37px;
	          }
	        }
	        .newlybuild {
	          margin: 0 auto;
	          cursor: pointer;
	          width: 221px;
	          height: 36px;
	          border: 2px solid #194abe;
	          border-radius: 4px;
	          display: flex;
	          justify-content: center;
	          align-items: center;
	          img {
	            width: 16px;
	            height: 16px;
	            margin-right: 7px;
	          }
	          p {
	            font-size: 14px;
	            font-family: Microsoft YaHei;
	            font-weight: 400;
	            line-height: 14px;
	            color: #194abe;
	          }
	        }
	        .form_box_content {
	          width: 100%;
	          .form_title {
	            box-sizing: border-box;
	            text-align: start;
	            display: flex;
	            p {
	              font-size: 16px;
	              font-family: Microsoft YaHei;
	              font-weight: bold;
	              line-height: 20px;
	              color: #0c0d0f;
	            }
	            .delete_icon {
	              cursor: pointer;
	              margin-left: 10px;
	              width: 61px;
	              height: 25px;
	              background: #ffffff;
	              border: 1px solid #f9656f;
	              opacity: 1;
	              border-radius: 6px;
	              display: flex;
	              align-items: center;
	              justify-content: space-evenly;
	              img {
	                width: 13px;
	                height: 14px;
	              }
	              p {
	                font-size: 14px;
	                font-family: Source Han Sans CN;
	                font-weight: 400;
	                line-height: 20px;
	                color: #f9656f;
	              }
	            }
	          }
	        }
	      }
	    }

	.flex {
	    display: flex;
	    align-items: center;
	  }
	  .my_form,
	  .my_form2 {
	    width: 100%;
	    height: 100%;
	    display: flex;
	    overflow: visible;
	    align-items: stretch;
		margin-bottom: 30px;
	    .form_title {
	      width: 80px;
	      min-width: 80px;
	      height: auto;
	      display: flex;
	      justify-content: left;
	      font-size: 14px;
	      font-family: Microsoft YaHei;
	      font-weight: 400;
	      line-height: 20px;
	      box-sizing: border-box;
	      color: #808895;
	    }
	    .form_content,
	    .form_long,
	    .form_content {
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		  width:230px;
	    }
		.form_textarea{
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		}
	  }
      .a01{
          color:#000;
      }
      .a01:hover{
          color:#194ABE;
          text-decoration:underline;
      }
      .a01:visited{
          color:#000;
      }
      .span02{
          font-weight: 400;
          color: #37C8AA;
          margin-left: 5px;
      }
      .span03{
          color: #B0B6C1;
          font-weight: 400;
      }
	  .spanText{
		  margin-top:25px;
		  font-size: 16px;
		  font-family: PingFang SC-Semibold, PingFang SC;
		  font-weight: 600;
		  color: #194ABE;
		  line-height: 0px;
		  -webkit-background-clip: text;
	  }
      .radio01{
          background:#F5F6F7;
          margin-bottom:15px;
          border: none !important;
          width:100px;
          margin-left: 10px;
          margin-right: 10px;
          white-space: nowrap;
          display: inline-block;
          overflow: hidden;
      }
      .pos-page {
      	position: absolute;
      	bottom: 0px !important;
      	width: 100%;
      }

      .infor {
          width: 1050px !important;
      }
      .w-1200 {
          width: 1500px  !important;
          margin: 0 auto;
      }
      .infor-t-r {
        width: 104px;
        height: 31px;
        border: 1px solid #7c828a;
        background: #194abe;
        color: #fff;
        border-radius: 5px;
        opacity: 1;
        overflow: hidden;
        display: table-cell;
        line-height: 31px;
        cursor: pointer
    }
    
    .infor-t-r img{
        vertical-align: middle
    }
    
    .infor-t-r span{
        font-size: 14px
    }
</style>
